import './style.css';
import {Map, View} from 'ol';
import GeoJSON from 'ol/format/GeoJSON';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import VectorImageLayer from 'ol/layer/VectorImage';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import OSM from 'ol/source/OSM';
import ImageLayer from 'ol/layer/Image';
import ImageSource from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import {Group as LayerGroup} from 'ol/layer';
import {Circle as CircleStyle, Fill, Stroke, Style, Text as TextStyle, Icon} from 'ol/style';
import Point from 'ol/geom/Point';

import Projection from 'ol/proj/Projection';
//import proj4 from 'proj4';
import {fromLonLat} from 'ol/proj';
import {register} from 'ol/proj/proj4';
import {transform} from 'ol/proj';

import Geolocation from 'ol/Geolocation';
import Feature from 'ol/Feature';
import Overlay from 'ol/Overlay';
import {ScaleLine as ScaleLineControl, defaults as defaultControls, FullScreen as FullScreenControl} from 'ol/control';
import Attribution from 'ol/control/Attribution';

import Select from 'ol/interaction/Select';
import {altKeyOnly, click, pointerMove} from 'ol/events/condition';

proj4.defs('EPSG:25833',
  '+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs');
register(proj4);
var deProjection = new Projection({
    code: 'EPSG:25833',
    extent: [-2465144, 4102893, 776625, 9408555]
    });

//verhindert, dass alle ajax-Anfragen auf alte Dateien in cache zugreifen
        $.ajaxSetup({ cache: false });

    // ---------- Layer-Definitionen ------------>
// ----------------------- Vektorlayer (GEOJSON)

                                    /////////////////////////// Wirtschaft und Entwicklung ///////////////////////////

//Vector-Layer f�r Wahllokale
    var WahllokaleNummerSource = new VectorSource({wrapX: false});
    var WahllokaleNummerVector = new VectorLayer({
        opacity:1,
        source: WahllokaleNummerSource
      });
//Vector-Layer f�r Wahllokale
    var WahllokaleBezirkSource = new VectorSource({wrapX: false});
    var WahllokaleBezirkVector = new VectorImageLayer({
        opacity:1,
        source: WahllokaleBezirkSource
      });
//Vector-Layer f�r Wahllokale
    var WahllokaleStandortSource = new VectorSource({wrapX: false});
    var WahllokaleStandortVector = new VectorLayer({
        opacity:1,
        source: WahllokaleStandortSource
      });

//Vector-Layer f�r Bebauungspl�ne
    var BPlaeneSource = new VectorSource({wrapX: false});
    var BPlaeneVector = new VectorImageLayer({
        opacity:1,
        source: BPlaeneSource
      });

//Vector-Layer f�r Bebauungspl�ne
    var VBPlaeneSource = new VectorSource({wrapX: false});
    var VBPlaeneVector = new VectorImageLayer({
        opacity:1,
        source: VBPlaeneSource
      });

//Vector-Layer f�r Bebauungspl�ne
    var BPlaeneUmringSource = new VectorSource({wrapX: false});
    var BPlaeneUmringVector = new VectorImageLayer({
        opacity:1,
        source: BPlaeneUmringSource
      });

//Vector-Layer f�r Bebauungspl�ne - Tif
    var BPlaeneTifSource = new VectorSource({wrapX: false});
    var BPlaeneTifVector = new VectorImageLayer({
        opacity:1,
        source: BPlaeneTifSource
      });

//Vector-Layer f�r Bebauungspl�ne - Tif
    var wmsSourceBPlaeneTif = new TileWMS({
      url: 'https://wms01.neubrandenburg.de/cgi-bin/mapserv?map=/data/umn/extern/B-Plaene/BPL_10_1-Aenderung_Satzung.map&',
      params: {
        'LAYERS': 'BPL_10_1-Aenderung_Satzung',
        'VERSION': '1.3.0',
        'FORMAT': 'image/png',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerBPlaeneTif = new TileLayer({
      visible:false,
      opacity: 0.6,
      source: wmsSourceBPlaeneTif
    });
    
//Vector-Layer f�r Bebauungspl�ne
var BPlaeneAufstellungSource = new VectorSource({ wrapX: false });
var BPlaeneAufstellungVector = new VectorImageLayer({
    opacity: 1,
    source: BPlaeneAufstellungSource
});

//Vector-Layer f�r Gewerbeimmobilien
    var GewerbeSource = new VectorSource({wrapX: false});
    var GewerbeVector = new VectorImageLayer({
        opacity:0.8,
        source: GewerbeSource
      });

//Vector-Layer f�r Statistik
    var StatistikAllSource = new VectorSource({wrapX: false});
    var StatistikAllVector = new VectorImageLayer({
        opacity:1,
        source: StatistikAllSource
      });

//Vector-Layer f�r Statistik
    var StatistikStadtteileSource = new VectorSource({wrapX: false});
    var StatistikStadtteileVector = new VectorImageLayer({
        opacity:1,
        source: StatistikStadtteileSource
      });
    
    //  Definition der Trasse Ortsumgehung -->
    var wmsSourceOrtsumgehung = new TileWMS({
      url: 'https://wms01.neubrandenburg.de/cgi-bin/mapserv?map=/data/umn/extern/Ortsumgehung/Ort_wms.map&',
      params: {
        'LAYERS': 'Ortsumgehung',
        'VERSION': '1.3.0',
        'FORMAT': 'image/png',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerOrtsumgehung = new TileLayer({
      visible:false,
      opacity: 0.6,
      source: wmsSourceOrtsumgehung
    });
    
//Vector-Layer f�r Einzelhandel
    var EinzelhandelSource = new VectorSource({wrapX: false});
    var EinzelhandelVector = new VectorLayer({
        opacity:1,
        source: EinzelhandelSource
      });
    
//Vector-Layer f�r Erhaltunssatzungen
    var ErhaltungssatzungenSource = new VectorSource({wrapX: false});
    var ErhaltungssatzungenVector = new VectorImageLayer({
        opacity:1,
        source: ErhaltungssatzungenSource
      });

//Vector-Layer f�r Bauaufsichtsbezirke
    var BauaufsichtsbezirkeSource = new VectorSource({wrapX: false});
    var BauaufsichtsbezirkeVector = new VectorLayer({
        opacity:0.6,
        source: BauaufsichtsbezirkeSource
      });
      
//Vector-Layer f�r Solarpotential
var SolarpotentialSource = new VectorSource({ wrapX: false });
var SolarpotentialVector = new VectorImageLayer({
    opacity: 1,
    source: SolarpotentialSource
});

//Vector-Layer f�r Wohnungsbaustandorte
var WohnungsbauSource = new VectorSource({ wrapX: false });
var WohnungsbauVector = new VectorImageLayer({
    opacity: 1,
    source: WohnungsbauSource
});


                                    /////////////////////////// Kultur und Tourismus ///////////////////////////

//Vector-Layer f�r Baudenkmalepl�ne
    var BaudenkmaleAllNeuSource = new VectorSource({wrapX: false});
    var BaudenkmaleAllNeuVector = new VectorLayer({
        opacity:1,
        source: BaudenkmaleAllNeuSource
      });

//Vector-Layer f�r Baudenkmalepl�ne
    var BaudenkmaleAll2018Source = new VectorSource({wrapX: false});
    var BaudenkmaleAll2018Vector = new VectorLayer({
        opacity:1,
        source: BaudenkmaleAll2018Source
      });

//Vector-Layer f�r Baudenkmalepl�ne
    var BaudenkmaleSource = new VectorSource({wrapX: false});
    var BaudenkmaleVector = new VectorLayer({
        opacity:1,
        source: BaudenkmaleSource
      });

//Vector-Layer f�r Baudenkmalepl�ne
    var BaudenkmaleFlaechenSource = new VectorSource({wrapX: false});
    var BaudenkmaleFlaechenVector = new VectorLayer({
        opacity:1,
        source: BaudenkmaleFlaechenSource
      });

//Vector-Layer f�r Denkmalbereiche
    var DenkmalbereicheSource = new VectorSource({wrapX: false});
    var DenkmalbereicheVector = new VectorLayer({
        opacity:1,
        source: DenkmalbereicheSource
      });

//Vector-Layer f�r Kunst im �ffentlichem Raum
    var KunstSource = new VectorSource({wrapX: false});
    var KunstVector = new VectorLayer({
        opacity:1,
        source: KunstSource
      });

//Vector-Layer f�r Kunst im �ffentlichem Raum
    var KunstAllSource = new VectorSource({wrapX: false});
    var KunstAllVector = new VectorLayer({
        opacity:1,
        source: KunstAllSource
      });

//Vector-Layer f�r Historische Pl�tze
    var HistoSource = new VectorSource({wrapX: false});
    var HistoVector = new VectorLayer({
        opacity:1,
        source: HistoSource
      });

//Vector-Layer f�r Tollensesee
    var TollenseseeSource = new VectorSource({wrapX: false});
    var TollenseseeVector = new VectorLayer({
        opacity:1,
        source: TollenseseeSource
      });

//Vector-Layer f�r Fahrgastschiffahrt
    var SchiffSource = new VectorSource({wrapX: false});
    var SchiffVector = new VectorLayer({
        opacity:1,
        source: SchiffSource
      });

//Vector-Layer f�r Strandb�der
    var StrandSource = new VectorSource({wrapX: false});
    var StrandVector = new VectorLayer({
        opacity:1,
        source: StrandSource
      });

//Vector-Layer f�r Strandb�der
    var StrandAugustabadSource = new VectorSource({wrapX: false});
    var StrandAugustabadVector = new VectorLayer({
        opacity:1,
        source: StrandAugustabadSource
      });

//Vector-Layer f�r Strandb�der
    var StrandBrodaSource = new VectorSource({wrapX: false});
    var StrandBrodaVector = new VectorLayer({
        opacity:1,
        source: StrandBrodaSource
      });

//Vector-Layer f�r Virtuellen Stadtrundgang
    var StadtrundgangSource = new VectorSource({wrapX: false});
    var StadtrundgangVector = new VectorLayer({
        opacity:1,
        source: StadtrundgangSource
      });

//  Definition des Brodaer Landschaftsgartens -->
    var wmsSourceLandschaftsgarten = new TileWMS({
      url: 'https://wms01.neubrandenburg.de/cgi-bin/mapserv?map=/data/umn/extern/Landschaftsgarten/lg_wms.map&',
      params: {
        'LAYERS': ['Landschaftsgarten', 'Point_of_Interest_Parken'],
        'VERSION': '1.3.0',
        'FORMAT': 'image/png',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerLandschaftsgarten = new TileLayer({
      visible:false,
      opacity: 1,
      source: wmsSourceLandschaftsgarten
    });
    
//Vector-Layer f�r Brodaer Landschaftsgarten
    var LandschaftsgartenSource = new VectorSource({wrapX: false});
    var LandschaftsgartenVector = new VectorLayer({
        opacity:1,
        source: LandschaftsgartenSource
      });

//  Definition des Radrundwegs -->
    var wmsSourceRadrundweg = new TileWMS({
      url: 'https://wms01.neubrandenburg.de/cgi-bin/mapserv?map=/data/umn/extern/Radweg/Radweg_wms.map&',
      params: {
        'LAYERS': ['Radweg'],
        'VERSION': '1.3.0',
        'FORMAT': 'image/png',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerRadrundweg = new TileLayer({
      visible:false,
      opacity: 1,
      source: wmsSourceRadrundweg
    });
    
//Vector-Layer f�r Spurensuche - Augenblick mal
    var SpurensucheSource = new VectorSource({wrapX: false});
    var SpurensucheVector = new VectorLayer({
        opacity:1,
        source: SpurensucheSource
      });

//Vector-Layer f�r E-Ladestationen
    var E_LadeSource = new VectorSource({wrapX: false});
    var E_LadeVector = new VectorLayer({
        opacity:1,
        source: E_LadeSource
      });


                                    /////////////////////////// Leben und Wohnen ///////////////////////////

//Vector-Layer f�r Eheschlie�ungsorte
    var StandesamtSource = new VectorSource({wrapX: false});
    var StandesamtVector = new VectorLayer({
        opacity:1,
        source: StandesamtSource
      });

//Vector-Layer f�r Friedh�fe
    var FriedhofSource = new VectorSource({wrapX: false});
    var FriedhofVector = new VectorLayer({
        opacity:1,
        source: FriedhofSource
      });

//Vector-Layer f�r Integration
    var IntegrationSource = new VectorSource({wrapX: false});
    var IntegrationVector = new VectorLayer({
        opacity:1,
        source: IntegrationSource
      });

//Vector-Layer f�r Hundefreilauffl�chen
    var HundeSource = new VectorSource({wrapX: false});
    var HundeVector = new VectorLayer({
        opacity:1,
        source: HundeSource
      });

//Vector-Layer f�r Hundefreilauffl�chen
    var HundeAlleSource = new VectorSource({wrapX: false});
    var HundeAlleVector = new VectorLayer({
        opacity:1,
        source: HundeAlleSource
      });

//Vector-Layer f�r Hundefreilauffl�chen
    var Hunde40cmSource = new VectorSource({wrapX: false});
    var Hunde40cmVector = new VectorLayer({
        opacity:1,
        source: Hunde40cmSource
      });

//Vector-Layer f�r Hundefreilauffl�chen
    var HundeTuetenSource = new VectorSource({wrapX: false});
    var HundeTuetenVector = new VectorLayer({
        opacity:1,
        source: HundeTuetenSource
      });

//Vector-Layer f�r Hundefreilauffl�chen
    var HundeStrandSource = new VectorSource({wrapX: false});
    var HundeStrandVector = new VectorLayer({
        opacity:1,
        source: HundeStrandSource
      });

//Vector-Layer f�r Hundefreilauffl�chen
    var HundeZeitSource = new VectorSource({wrapX: false});
    var HundeZeitVector = new VectorLayer({
        opacity:1,
        source: HundeZeitSource
      });


                                    /////////////////////////// Sicherheit und Ordnung ///////////////////////////

//Vector-Layer f�r �ffentliche WC
    var CityWCSource = new VectorSource({wrapX: false});
    var CityWCVector = new VectorLayer({
        opacity:1,
        source: CityWCSource
      });

//Vector-Layer f�r Stra�enreinigung
    var ReinigungSource = new VectorSource({wrapX: false});
    var ReinigungVector = new VectorLayer({
        opacity:1,
        source: ReinigungSource
      });

//Vector-Layer f�r Winterdienst
    var Winterdienst1Source = new VectorSource({wrapX: false});
    var Winterdienst1Vector = new VectorLayer({
        opacity:1,
        source: Winterdienst1Source
      });

//Vector-Layer f�r Winterdienst
    var Winterdienst2Source = new VectorSource({wrapX: false});
    var Winterdienst2Vector = new VectorLayer({
        opacity:1,
        source: Winterdienst2Source
      });

//Vector-Layer f�r ParkplatzPark
    var ParkplatzParkSource = new VectorSource({wrapX: false});
    var ParkplatzParkVector = new VectorLayer({
        opacity:1,
        source: ParkplatzParkSource
      });

//Vector-Layer f�r ParkplatzBus
    var ParkplatzBusSource = new VectorSource({wrapX: false});
    var ParkplatzBusVector = new VectorLayer({
        opacity:1,
        source: ParkplatzBusSource
      });

//Vector-Layer f�r ParkplatzLKW
    var ParkplatzLKWSource = new VectorSource({wrapX: false});
    var ParkplatzLKWVector = new VectorLayer({
        opacity:1,
        source: ParkplatzLKWSource
      });

//Vector-Layer f�r P15 Parktickets
    var P15Source = new VectorSource({wrapX: false});
    var P15Vector = new VectorLayer({
        opacity:1,
        source: P15Source
      });

//Vector-Layer f�r Fruehjahrsputz
    var FruehjahrsputzSource = new VectorSource({wrapX: false});
    var FruehjahrsputzVector = new VectorLayer({
        opacity:1,
        source: FruehjahrsputzSource
      });


                                    /////////////////////////// Bildung und Sport ///////////////////////////

//Vector-Layer f�r Schulen
var SchulenSource = new VectorSource({ wrapX: false });
var SchulenVector = new VectorLayer({
    opacity: 1,
    source: SchulenSource
});

//Vector-Layer f�r Schulen
var KitasSource = new VectorSource({ wrapX: false });
var KitasVector = new VectorLayer({
    opacity: 1,
    source: KitasSource
});

//Vector-Layer f�r Sportst�tten
    var SportplaetzeSource = new VectorSource({wrapX: false});
    var SportplaetzeVector = new VectorLayer({
        opacity:1,
        source: SportplaetzeSource
      });

//Vector-Layer f�r Sportst�tten
    var SpielplaetzeSource = new VectorSource({wrapX: false});
    var SpielplaetzeVector = new VectorLayer({
        opacity:1,
        source: SpielplaetzeSource
      });


// ----------------------- Ende Vektorlayer (GEOJSON)

                                    /////////////////////////// Umwelt ///////////////////////////

    //  Definition der Schutzgebiete --> //kann Fl�chen darstellen, m�chte aber nicht Abfrage nach FeatureInfo, da CrossOrigin
    var wmsSourceMVSchutz = new TileWMS({
      url: 'https://www.umweltkarten.mv-regierung.de/script/mv_a2_schutzgeb_wms.php?language=ger&',
      params: {
        'LAYERS': ['t2_np_f', 't2_spamv_f', 't2_brn_f', 't2_nsgawz', 't2_nlp_f', 't2_lpv_c', 't2_glb_f', 't2_fnd_p', 't2_nlpjvo', 't2_nlpz_f', 't2_lpv_c_spa', 't2_spaawz', 't2_fnd_f', 't2_ffhmv_p', 't2_brnz_f', 't2_ffhawz', 't2_ffhmv_f', 't2_kgss_mv', 't2_nsg_f', 't2_nat_wald', 't2_lsg_f'],
        'VERSION': '1.3.0',
        'FORMAT': 'image/gif',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerMVSchutz = new TileLayer({
      visible:false,
      opacity: 0.6,
      source: wmsSourceMVSchutz
    });
    

                                    /////////////////////////// Weitere Karten ///////////////////////////

        //  Definition der Kommunale Fl�chen -->
    var wmsSourceKommunFl = new TileWMS({
      url: 'https://wms02.neubrandenburg.de/kommunale_flaechen/ProOpenPlusWMS.dll?',
      params: {
        'LAYERS': 'V_0_0',
        'VERSION': '1.3.0',
        'FORMAT': 'image/gif',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerKommunFl = new TileLayer({
      visible:false,
      opacity: 0.6,
      source: wmsSourceKommunFl
    });
    
//  Definition der Stadtkarte -->
    var wmsSourceStadtkarte = new TileWMS({
      url: 'https://WMS02.neubrandenburg.de/stadtkarte/ProOpenPlusWMS.dll?',
      params: {
        'LAYERS': ['V_0_0', 'V_0_1', 'V_0_2', 'V_0_3', 'V_0_4'],
        'VERSION': '1.3.0',
        'FORMAT': 'image/gif',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerStadtkarte = new TileLayer({
      visible:false,
      minResolution: 0,
      maxResolution: 0.5,
      source: wmsSourceStadtkarte
    });

    //  Definition der �bersichtskarte -->
    var wmsSourceUebersichtskarte = new TileWMS({
      url: 'https://wms02.neubrandenburg.de/overview/ProOpenPlusWMS.dll?',
      params: {
        'LAYERS': ['V_0_0', 'V_0_1', 'V_0_2'],
        'VERSION': '1.3.0',
        'FORMAT': 'image/gif',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    var wmsLayerUebersichtskarte = new TileLayer({
      visible:false,
      source: wmsSourceUebersichtskarte
    });

    //  Definition des DOP-Layers - Luftbild -->
    var wmsSourceDOP = new TileWMS({
      url: 'https://www.geodaten-mv.de/dienste/adv_dop?language=ger&',
      params: {
        'LAYERS': 'mv_dop',
        'VERSION': '1.3.0',
        'FORMAT': 'image/png',
        'TILED': true
      },
      serverType: 'mapserver'
    });
    var wmsLayerDOP = new TileLayer({
      visible:false,
      source: wmsSourceDOP
    });

    //  Definition des ORKA-MV-Layers -->
    var wmsSourceORKA = new TileWMS({
      url: 'https://www.orka-mv.de/geodienste/orkamv/wms?',
      params: {
        'LAYERS': 'orkamv',
        'VERSION': '1.3.0',
        'FORMAT': 'image/jpeg'
      },
      serverType: 'mapserver'
    });
    var wmsLayerORKA = new TileLayer({
      visible:true,
      source: wmsSourceORKA
    });
wmsLayerORKA.setVisible(false);

var wmsLayerOSM = new TileLayer({
    source: new OSM()
});
wmsLayerOSM.setVisible(false);
var OSMWmsSource = new ImageWMS({
    url: 'https://wms01.neubrandenburg.de/cgi-bin/mapserv?map=/data/umn/extern/OSM/osm_covered.map&',
    params: {
        'LAYERS': 'Parkplatz_Fritscheshof_s_modifiziert,osm_covered',
        'VERSION': '1.3.0',
        'FORMAT': 'image/png'
    },
    serverType: 'mapserver',
    crossorigin: 'anonymous'
});
var OSMWmsLayer = new ImageLayer({
    opacity: 1,
    visible: true,
    source: OSMWmsSource
});
OSMWmsLayer.setVisible(false);

                                    /////////////////////////// Layer f�r Funktionen des Mobilen GIS ///////////////////////////

    // Definition des Layers, der die Punktobjekte f�r die Hausnummern enth�lt -->
    var HausnummerSource = new VectorSource({wrapX: false});
    var HausnummerVector = new VectorLayer({
        source: HausnummerSource,
        style: new Style({
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.5)'
          }),
          stroke: new Stroke({
            color: 'rgba(0, 0, 255, 1)',
            width: 2
          }),
          image: new CircleStyle({
            radius: 10,                         //Style des aufgerufenen Punktes ist in function.js
            fill: new Fill({
              color: 'rgba(238, 156, 7, 0.5)'
            }),
            stroke: new Stroke({
              color: 'rgba(238, 156, 7, 1)',
              width: 2
            })
          })
        })
      });

    var POISource = new VectorSource({wrapX: false});
    var POIVector = new VectorLayer({
        source: POISource,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.5)'
          }),
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 1)',
            width: 2
          }),
          image: new CircleStyle({
            radius: 10,
            fill: new Fill({
              color: 'rgba(255, 255, 255, 1)'
            }),
            stroke: new Stroke({
              color: 'rgba(0, 0, 0, 1)',
              width: 2
            })
          }),
          text: new TextStyle({
            font: '20px sans-serif'
          })
        })
      });
 
//Openlayers
const style = new Style({
  fill: new Fill({
    color: '#eeeeee',
  }),
});

const view = new View({
      center: [384807, 5935654],
      projection: 'EPSG:25833',
      zoom: 17,
      enableRotation:false
  });

// -- Beginn Funktionen f�r Geolocation
var geolocation = new Geolocation({
  // enableHighAccuracy must be set to true to have the heading value.
  trackingOptions: {
    enableHighAccuracy: true
  },
  projection: view.getProjection()
});

function el(id) {
  return document.getElementById(id);
}

var onClickGeolocation = document.querySelector("a[id=Geolocation]");
onClickGeolocation.addEventListener('click', function() {
    var element = document.getElementById('GeolocationImg');
    var source=element.src;
    if(source=='https://geoserver.neubrandenburg.de/Bilder/Marker/marker_blau.png'){
               geolocation.setTracking(true);
               positionLayer.setVisible(true);
               element.src="https://geoserver.neubrandenburg.de/Bilder/Marker/marker_schwarz.png";
    }
    else if (source=='https://geoserver.neubrandenburg.de/Bilder/Marker/marker_schwarz.png'){
               geolocation.setTracking(false);
               positionLayer.setVisible(false);
               element.src="https://geoserver.neubrandenburg.de/Bilder/Marker/marker_blau.png";
    }
    
    
});

// handle geolocation error.
geolocation.on('error', function(error) {
});

const accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function() {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

var positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({
        color: '#3399CC',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2,
      }),
    }),
  })
);

geolocation.on('change:position', function () {
  const coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
});

      var positionLayer = new VectorLayer({
        map: map,
        source: new VectorSource({
          features: [accuracyFeature, positionFeature]
        }),
        style: new Style({
          fill: new Fill({
            color: 'rgba(0, 204, 255, 0.3)'
          }),
          stroke: new Stroke({
            color: 'rgba(0, 102, 255, 0.5)',
            width: 7
          }),
          image: new CircleStyle({
            radius: 11,
            stroke: new Stroke({
              color: 'rgba(0, 0, 0, 0.75)',
              width: 7
            }),
            fill: new Fill({
              color: 'rgba(0, 102, 255, 0.75)'
            })
          })
        })
      });


// -- Ende Funktionen f�r Geolocation

var extentNB = [350305.0001, 5897852.0001, 418417.9999, 5970736.9999];
    //  Definitionen f�r die Objektabfrage -->
    var container = document.getElementById('popup');
    var content = document.getElementById('popup-content');
    var closer = document.getElementById('popup-closer');
    closer.onclick = function() {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };
    var overlay = new Overlay(/** @type {olx.OverlayOptions} */ ({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    }));


    //  Definition der Ma�stabsleiste  //
    var scaleLineControl = new ScaleLineControl();

    //  Definition des Attribution(Urheberrecht)-Button  //
    var attribution = new Attribution({
      collapsible: true,
        label: '\u00A9', // � &copy; funktioniert nicht 
      collapsed: true,
        tipLabel: 'Zuordnungen',
        id: 'Zuordnungen'
    });

    //  Definition der Karte  //
    var map = new Map({
      controls: new defaultControls({
        attribution: false //  verhindert den Standard-Attributions-Button  //
      }).extend([
        attribution, //  setzt den eigenen Attributions-Button  //
        scaleLineControl, //  hier wird die Ma�stabsleiste der map hinzugef�gt  //
        new FullScreenControl({ //  bringt einen Button f�r die Full-Screen-Anzeige  //
          source:fullscreen
        })
      ]),
      overlays: [overlay],
      target: 'map',
      layers: [
//        new TileLayer({
//          source: new OSM()
//        }),
        BPlaeneTifVector, 
          wmsLayerOSM, OSMWmsLayer,
        wmsLayerORKA,
        wmsLayerDOP,
        wmsLayerUebersichtskarte,
        wmsLayerStadtkarte,
        wmsLayerKommunFl,
        wmsLayerMVSchutz,
        SpielplaetzeVector,
        SportplaetzeVector,
          KitasVector,
          SchulenVector,
        FruehjahrsputzVector,
        P15Vector,
        ParkplatzParkVector, ParkplatzBusVector, ParkplatzLKWVector,
        Winterdienst2Vector, Winterdienst1Vector,
        ReinigungVector,
        CityWCVector,
        HundeVector, HundeAlleVector, Hunde40cmVector, HundeTuetenVector, HundeStrandVector, HundeZeitVector,
        IntegrationVector,
        FriedhofVector,
        StandesamtVector,
        E_LadeVector,
        SpurensucheVector,
        wmsLayerRadrundweg, 
        wmsLayerLandschaftsgarten, LandschaftsgartenVector,
        StadtrundgangVector,
        StrandBrodaVector, StrandAugustabadVector, StrandVector,
        SchiffVector,
        TollenseseeVector,
        HistoVector,
        KunstAllVector,
        KunstVector,
        DenkmalbereicheVector,
        BaudenkmaleFlaechenVector,
        BaudenkmaleVector,  
          BaudenkmaleAllNeuVector, BaudenkmaleAll2018Vector,
          WohnungsbauVector,
        SolarpotentialVector, 
        BauaufsichtsbezirkeVector,
        ErhaltungssatzungenVector,
        EinzelhandelVector, 
        wmsLayerOrtsumgehung,
        StatistikStadtteileVector, StatistikAllVector,
          GewerbeVector, 
        BPlaeneVector, 
          VBPlaeneVector,
          BPlaeneAufstellungVector,
          BPlaeneUmringVector, 
        wmsLayerBPlaeneTif,
        WahllokaleBezirkVector, WahllokaleNummerVector, WahllokaleStandortVector,
        HausnummerVector,
        positionLayer,
        POIVector
      ],
      view: view
    });




    //Funktion, die bewirkt, dass zum Startbildschirm gesprungen wird

function onClick(id, callback) {
        document.getElementById(id).addEventListener('click', callback);
}
onClick('zoomHome', function() {
  view.animate({
      center: [384807, 5935654],
      projection: 'EPSG:25833',
      rotation: 0,
      zoom: 14,
      duration: 0
  });
});

//Openlayers
let select = null; // ref to currently selected interaction
const selected = new Style({
  fill: new Fill({
    color: '#eeeeee',
  }),
  stroke: new Stroke({
    color: 'rgba(255, 255, 255, 0.7)',
    width: 2,
  })
});
function selectStyle(feature) {
  const color = feature.get('COLOR') || '#eeeeee';
  selected.getFill().setColor(color);
  return selected;
}
// select interaction working on "singleclick"
const selectSingleClick = new Select({style: selectStyle});
const selectElement = 'click';

//Felder fuer alle Elemente eines Vorganges hinzufuegen
gesamteFelder();

//enth�llt alle Felder, die f�r alle Elemente eines Vorganges gelten; input-Elemente m�ssen au�erhalb anderer Elemente sein, damit sie mit <form> benutzt werden k�nnen
function gesamteFelder(){
        //die value-Werte m�ssen mit den Werten der Startseite �bereinstimmen, da es sonst zu Problemen gib, wenn keine �nderungen vorgenommen wurden
        var viewFelder =
           '<input type="hidden" id="zoomData" name="zoomData"/>'+
           '<input type="hidden" id="centerData" name="centerData"/>'+
           '<input type="hidden" id="rotationData" name="rotationData"/>'+
           ''; 
        document.getElementById("formLarge").innerHTML = viewFelder;
}

// -- Beginn Auslesen der GEOJSON



                //----------- Ende GEOJSON Auslesen ausgelagert mittels ajax ------------------------------


// -- Ende Auslesen der GEOJSON

// ----------------------- Ende der Funktionen ------------------------------- //
//When auf Karte gleickt wird

    map.on('click', function (event){
        //reset Template
        if (!(document.getElementById('TemplateTabsInc') == undefined)){ //wenn ein Element mit der id existiert
            document.getElementById("TemplateTabs").innerHTML = '';
            document.getElementById("TemplateContents").innerHTML = '';
        }
    });


    // Beginn Definition des GetFeatureInfo()-Select der GEOJSON //


                                    /////////////////////////// Wirtschaft und Entwicklung ///////////////////////////

var Wahllokale_2022Select = new Select({
    condition: click,
    layers: [WahllokaleStandortVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(Wahllokale_2022Select);


var BPlaeneSelect = new Select({
    condition: click,
    layers: [BPlaeneVector, VBPlaeneVector, BPlaeneUmringVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(BPlaeneSelect);

var BPlaeneTifSelect = new Select({
    condition: click,
    layers: [BPlaeneTifVector],      //wmsLayerBPlaeneTif
    multi: true, hitTolerance: 5
});
map.addInteraction(BPlaeneTifSelect);

var GewerbeSelect = new Select({
    condition: click,
    layers: [GewerbeVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(GewerbeSelect);

var StatistikSelect = new Select({
    condition: click,
    layers: [StatistikStadtteileVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(StatistikSelect);

var EinzelhandelSelect = new Select({
    condition: click,
    layers: [EinzelhandelVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(EinzelhandelSelect);

var ErhaltungssatzungenSelect = new Select({
    condition: click,
    layers: [ErhaltungssatzungenVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(ErhaltungssatzungenSelect);

var BauaufsichtsbezirkeSelect = new Select({
    condition: click,
    layers: [BauaufsichtsbezirkeVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(BauaufsichtsbezirkeSelect);

var SolarpotentialSelect = new Select({
    condition: click,
    layers: [SolarpotentialVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(SolarpotentialSelect);

var WohnungsbauSelect = new Select({
    condition: click,
    layers: [WohnungsbauVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(WohnungsbauSelect);


                                    /////////////////////////// Kultur und Tourismus ///////////////////////////

var BaudenkmaleSelect1 = new Select({
    condition: click,
    layers: [BaudenkmaleVector, BaudenkmaleAllNeuVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(BaudenkmaleSelect1);

var BaudenkmaleSelect2 = new Select({
    condition: click,
    layers: [BaudenkmaleAll2018Vector],
    multi: true, hitTolerance: 5
});
map.addInteraction(BaudenkmaleSelect2);

var DenkmalbereicheSelect = new Select({
    condition: click,
    layers: [DenkmalbereicheVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(DenkmalbereicheSelect);

var KunstSelect = new Select({
    condition: click,
    layers: [KunstVector, KunstAllVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(KunstSelect);

var HistoSelect = new Select({
    condition: click,
    layers: [HistoVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(HistoSelect);

var TollenseseeSelect = new Select({
    condition: click,
    layers: [TollenseseeVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(TollenseseeSelect);

var SchiffSelect = new Select({
    condition: click,
    layers: [SchiffVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(SchiffSelect);

var StrandSelect = new Select({
    condition: click,
    layers: [StrandVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(StrandSelect);

var StrandAugustabadSelect = new Select({
    condition: click,
    layers: [StrandAugustabadVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(StrandAugustabadSelect);

var StrandBrodaSelect = new Select({
    condition: click,
    layers: [StrandBrodaVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(StrandBrodaSelect);

var StadtrundgangSelect = new Select({
    condition: click,
    layers: [StadtrundgangVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(StadtrundgangSelect);

var LandschaftsgartenSelect = new Select({
    condition: click,
    layers: [LandschaftsgartenVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(LandschaftsgartenSelect);

var SpurensucheSelect = new Select({
    condition: click,
    layers: [SpurensucheVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(SpurensucheSelect);

var E_LadeSelect = new Select({
    condition: click,
    layers: [E_LadeVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(E_LadeSelect);

                                    /////////////////////////// Leben und Wohnen ///////////////////////////

var StandesamtSelect = new Select({
    condition: click,
    layers: [StandesamtVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(StandesamtSelect);

var FriedhofSelect = new Select({
    condition: click,
    layers: [FriedhofVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(FriedhofSelect);

var IntegrationSelect = new Select({
    condition: click,
    layers: [IntegrationVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(IntegrationSelect);

var HundeSelect = new Select({
    condition: click,
    layers: [HundeVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(HundeSelect);
var HundeAlleSelect = new Select({
    condition: click,
    layers: [HundeAlleVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(HundeAlleSelect);
var Hunde40cmSelect = new Select({
    condition: click,
    layers: [Hunde40cmVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(Hunde40cmSelect);
var HundeTuetenSelect = new Select({
    condition: click,
    layers: [HundeTuetenVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(HundeTuetenSelect);


                                    /////////////////////////// Sicherheit und Ordnung ///////////////////////////

var CityWCSelect = new Select({
    condition: click,
    layers: [CityWCVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(CityWCSelect);

var ReinigungSelect = new Select({
    condition: click,
    layers: [ReinigungVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(ReinigungSelect);

var Winterdienst1Select = new Select({
    condition: click,
    layers: [Winterdienst1Vector],
    multi: true, hitTolerance: 5
});
map.addInteraction(Winterdienst1Select);

var Winterdienst2Select = new Select({
    condition: click,
    layers: [Winterdienst2Vector],
    multi: true, hitTolerance: 5
});
map.addInteraction(Winterdienst2Select);

var ParkplatzParkSelect = new Select({
    condition: click,
    layers: [ParkplatzParkVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(ParkplatzParkSelect);

var ParkplatzBusSelect = new Select({
    condition: click,
    layers: [ParkplatzBusVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(ParkplatzBusSelect);

var ParkplatzLKWSelect = new Select({
    condition: click,
    layers: [ParkplatzLKWVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(ParkplatzLKWSelect);

var P15Select = new Select({
    condition: click,
    layers: [P15Vector],
    multi: true, hitTolerance: 5
});
map.addInteraction(P15Select);


                                    /////////////////////////// Bildung und Sport ///////////////////////////

var SchulenSelect = new Select({
    condition: click,
    layers: [SchulenVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(SchulenSelect);

var KitasSelect = new Select({
    condition: click,
    layers: [KitasVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(KitasSelect);

var SportplaetzeSelect = new Select({
    condition: click,
    layers: [SportplaetzeVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(SportplaetzeSelect);

var SpielplaetzeSelect = new Select({
    condition: click,
    layers: [SpielplaetzeVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(SpielplaetzeSelect);

var FruehjahrsputzSelect = new Select({
    condition: click,
    layers: [FruehjahrsputzVector],
    multi: true, hitTolerance: 5
});
map.addInteraction(FruehjahrsputzSelect);


    // Ende Definition des GetFeatureInfo()-Select der GEOJSON //

    // Beginn Definition des GetFeatureInfo()-Select der Image-WMS //
var MVSchutzSelect = new Select({
    condition: click,
    layers: [wmsLayerMVSchutz],
    multi: true, hitTolerance: 5
});
map.addInteraction(MVSchutzSelect);
    
    // Ende Definition des GetFeatureInfo()-Select der Image-WMS //
    
// --------------------------------- Beginn der Events ------------------------------------------ //


// Beginn wenn Element von den Vector-Layers ausgew�hlt oder Auwahl entfernt wurde //

                                    /////////////////////////// Wirtschaft und Entwicklung ///////////////////////////

    Wahllokale_2022Select.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Wahllokale_2022', 'Wahlkarte 2022'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getWahllokale_2022FeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#Wahllokale_2022TemplateContent").html(result);
               }
            });
    });

    BPlaeneSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('BPlaene', 'Bebauungspl&auml;ne'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getBPlaeneFeatureInfo2.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#BPlaeneTemplateContent").html(result);
               }
            });
    });

    BPlaeneTifSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('BPlaeneTif', 'Bebauungspl&auml;ne');

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getBPlaeneTifFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#BPlaeneTifTemplateContent").html(result);
               }
            });
    });

    GewerbeSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Gewerbe', 'Gewerbeimmobilien'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getGewerbeFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#GewerbeTemplateContent").html(result);
               }
            });
    });

    StatistikSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Statistik', 'Statistik'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getStatistikFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#StatistikTemplateContent").html(result);
               }
            });
    });

    EinzelhandelSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Einzelhandel', 'Einzelhandelsstandorte'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getEinzelhandelFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#EinzelhandelTemplateContent").html(result);
               }
            });
    });

    ErhaltungssatzungenSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Erhaltungssatzungen', 'Erhaltungssatzungen'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getErhaltungssatzungenFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#ErhaltungssatzungenTemplateContent").html(result);
               }
            });
    });

    BauaufsichtsbezirkeSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Bauaufsichtsbezirke', 'Bauaufsichtsbezirke'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getBauaufsichtsbezirkeFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#BauaufsichtsbezirkeTemplateContent").html(result);
               }
            });
    });

SolarpotentialSelect.on('select', function (event) {
    var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
    buildTab('Solarpotential', 'Solarpotentialimmobilien');
    var collection = this.getFeatures();
    var featureGeoJSON = new Array();
    var anzElements = collection.getLength();
    for (var i = 0; i < anzElements; i++) {
        featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
    }
    $.ajax({
        type: "POST",
        url: "../../lib7/functions/templates/getSolarpotentialFeatureInfo.php",
        data: { features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn },
        success: function (result) {
            $("#SolarpotentialTemplateContent").html(result);
        }
    });
});

WohnungsbauSelect.on('select', function (event) {
    var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
    buildTab('Wohnungsbau', 'Wohnungsbauimmobilien');
    var collection = this.getFeatures();
    var featureGeoJSON = new Array();
    var anzElements = collection.getLength();
    for (var i = 0; i < anzElements; i++) {
        featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
    }
    $.ajax({
        type: "POST",
        url: "../../lib7/functions/templates/getWohnungsbauFeatureInfo.php",
        data: { features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn },
        success: function (result) {
            $("#WohnungsbauTemplateContent").html(result);
        }
    });
});

                                    /////////////////////////// Kultur und Tourismus ///////////////////////////

    BaudenkmaleSelect1.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Baudenkmale1', 'Baudenkmale'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getBaudenkmale1FeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#Baudenkmale1TemplateContent").html(result);
               }
            });
    });

    BaudenkmaleSelect2.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Baudenkmale2', 'Baudenkmale');
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getBaudenkmale2FeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#Baudenkmale2TemplateContent").html(result);
               }
            });
    });

    DenkmalbereicheSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Denkmalbereiche', 'Denkmalbereiche'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getDenkmalbereicheFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#DenkmalbereicheTemplateContent").html(result);
               }
            });
    });

    KunstSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Kunst', 'Kunst im &ouml;ffentlichem Raum'); /*getKunstFeatureInfo(this.getFeatures());*/

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getKunstFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#KunstTemplateContent").html(result);
               }
            });
    });                                                                      

    HistoSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Histo', 'Historische Pl&auml;tze'); /*getHistoFeatureInfo(this.getFeatures());*/
    
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getHistoFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#HistoTemplateContent").html(result);
               }
            });
    });

    TollenseseeSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Tollensesee', 'Tollensesee'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getTollenseseeFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#TollenseseeTemplateContent").html(result);
               }
            });
    });

    SchiffSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Schiff', 'Fahrgastschifffahrt'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getSchiffFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#SchiffTemplateContent").html(result);
               }
            });
    });

    StrandSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Strand', 'Strandb&auml;der'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getStrandFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#StrandTemplateContent").html(result);
               }
            });
    });

    StrandAugustabadSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Strand', 'Strandb&auml;der'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getStrandAugustabadFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#StrandTemplateContent").html(result);
               }
            });
    });

    StrandBrodaSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Strand', 'Strandb&auml;der'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getStrandBrodaFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#StrandTemplateContent").html(result);
               }
            });
    });                                                                                                 

    StadtrundgangSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Stadtrundgang', 'Virtueller Stadtrundgang');
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getStadtrundgangFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#StadtrundgangTemplateContent").html(result);
               }
            });
    });

    LandschaftsgartenSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Landschaftsgarten', 'Brodaer Landschaftsgarten'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getLandschaftsgartenFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#LandschaftsgartenTemplateContent").html(result);
               }
            });
    });

    SpurensucheSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Spurensuche', 'Spurensuche - Augenblick mal'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getSpurensucheFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#SpurensucheTemplateContent").html(result);
               }
            });
    });

    E_LadeSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('E_Lade', 'E-Ladestationen');
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getE_LadeFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#E_LadeTemplateContent").html(result);
               }
            });
    });

                                    /////////////////////////// Leben und Wohnen ///////////////////////////

    StandesamtSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Standesamt', 'Eheschlie&szlig;ungsorte'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getStandesamtFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#StandesamtTemplateContent").html(result);
               }
            });
    });

    FriedhofSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Friedhof', 'Friedh&ouml;fe');
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getFriedhofFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#FriedhofTemplateContent").html(result);
               }
            });
    });

    IntegrationSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Integration', 'Integration'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getIntegrationFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#IntegrationTemplateContent").html(result);
               }
            });
    });

    HundeSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Hunde', 'Mit dem Hund unterwegs'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
                url: "../../lib7/functions/templates/getHundeFeatureInfo4.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#HundeTemplateContent").html(result);
               }
            });
    });
    HundeAlleSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Hunde', 'Mit dem Hund unterwegs'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
                url: "../../lib7/functions/templates/getHundeFeatureInfo4.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#HundeTemplateContent").html(result);
               }
            });
    });
    Hunde40cmSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Hunde', 'Mit dem Hund unterwegs');
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
                url: "../../lib7/functions/templates/getHundeFeatureInfo4.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#HundeTemplateContent").html(result);
               }
            });
    });
HundeTuetenSelect.on('select', function (event) {
    var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
    buildTab('Hunde', 'Mit dem Hund unterwegs');
    var collection = this.getFeatures();
    var featureGeoJSON = new Array();
    var anzElements = collection.getLength();
    for (var i = 0; i < anzElements; i++) {//isnull
        var currentFeature = collection.pop();
        var Foto = currentFeature.get('Foto');
        if (!Foto) {
        }
        else {
            console.log('Foto:' + Foto);
            var currentGeoJSON = new GeoJSON().writeFeature(currentFeature);
            featureGeoJSON.push(currentGeoJSON);

        }
    }
    $.ajax({
        type: "POST",
        url: "../../lib7/functions/templates/getHundeTuetenFeatureInfo.php",
        data: { features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn },
        success: function (result) {
            $("#HundeTemplateContent").html(result);
        }
    });

    document.getElementById('TemplateFooter').innerHTML = '<button type="button" class="btn btn-success" data-dismiss="modal" id="TemplateClose" style="font-size:14px">Zur&uuml;ck</button>';
});


                                    /////////////////////////// Sicherheit und Ordnung ///////////////////////////

    CityWCSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('CityWC', 'City-WC'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getCityWCFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#CityWCTemplateContent").html(result);
               }
            });
    });

    ReinigungSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Reinigung', 'Stra&szlig;enreinigung'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getReinigungFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#ReinigungTemplateContent").html(result);
               }
            });
    });

    Winterdienst1Select.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Winterdienst', 'Winterdienst');

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getWinterdienst1FeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#WinterdienstTemplateContent").html(result);
               }
            });
    });

    Winterdienst2Select.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Winterdienst', 'Winterdienst'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getWinterdienst2FeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#WinterdienstTemplateContent").html(result);
               }
            });
    });

    ParkplatzParkSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Parkplatz', 'Parkpl&auml;tze'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getParkplatzParkFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#ParkplatzTemplateContent").html(result);
               }
            });
    });
    ParkplatzBusSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Parkplatz', 'Parkpl&auml;tze'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getParkplatzBusFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#ParkplatzTemplateContent").html(result);
               }
            });
    });
    ParkplatzLKWSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Parkplatz', 'Parkpl&auml;tze'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getParkplatzLKWFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#ParkplatzTemplateContent").html(result);
               }
            });
    });

    P15Select.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('P15', 'P15 Parktickets'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getP15FeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#P15TemplateContent").html(result);
               }
            });
    });

    FruehjahrsputzSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Fruehjahrsputz', 'Fruehjahrsputz'); 
        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getFruehjahrsputzFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#FruehjahrsputzTemplateContent").html(result);
               }
            });
    });


                                    /////////////////////////// Bildung und Sport ///////////////////////////

SchulenSelect.on('select', function (event) {
    var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
    buildTab('Schulen', 'Schulen');

    var collection = this.getFeatures();
    var featureGeoJSON = new Array();
    var anzElements = collection.getLength();
    for (var i = 0; i < anzElements; i++) {
        featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
    }
    $.ajax({
        type: "POST",
        url: "../../lib7/functions/templates/getSchulenFeatureInfo.php",
        data: { features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn },
        success: function (result) {
            $("#SchulenTemplateContent").html(result);
        }
    });
});

KitasSelect.on('select', function (event) {
    var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
    buildTab('Kitas', 'Kindertagesst&auml;tten');

    var collection = this.getFeatures();
    var featureGeoJSON = new Array();
    var anzElements = collection.getLength();
    for (var i = 0; i < anzElements; i++) {
        featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
    }
    $.ajax({
        type: "POST",
        url: "../../lib7/functions/templates/getKitasFeatureInfo.php",
        data: { features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn },
        success: function (result) {
            $("#KitasTemplateContent").html(result);
        }
    });
});

    SportplaetzeSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Sportplaetze', 'Sportst&auml;tten'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getSportplaetzeFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#SportplaetzeTemplateContent").html(result);
               }
            });
    });

    SpielplaetzeSelect.on('select', function (event){
        var gtFInf__tkn = document.getElementById('gtFInf__tkn').value;
        buildTab('Spielplaetze', 'Spielpl&auml;tze'); 

        var collection = this.getFeatures();
        var featureGeoJSON = new Array();
        var anzElements = collection.getLength();
        for (var i=0;i<anzElements;i++){
            featureGeoJSON.push(new GeoJSON().writeFeature(collection.pop()));
        }
            $.ajax({
               type: "POST",
               url: "../../lib7/functions/templates/getSpielplaetzeFeatureInfo.php",
               data: {features: featureGeoJSON, gtFInf__tkn: gtFInf__tkn},
               success: function(result) {
                        $("#SpielplaetzeTemplateContent").html(result);
               }
            });
    });



// Ende wenn Element von den Vector-Layers ausgew�hlt oder Auwahl entfernt wurde //

// Beginn wenn Element von den Image-Layers ausgew�hlt oder Auwahl entfernt wurde //
    MVSchutzSelect.on('select', function (event){
        document.getElementById('TemplateBody').innerHTML = '';
  var viewResolution = /** @type {number} */ (view.getResolution());

  var url = wmsSourceMVSchutz.getFeatureInfoUrl(
    event.coordinate,
    viewResolution,
    'EPSG:25833',
    {'INFO_FORMAT': 'text/html'}
  );
  if (url) {
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        document.getElementById('TemplateBody').innerHTML += html;
    $('#TemplateModal').modal();
      });
  }

    });

// Ende wenn Element von den Image-Layers ausgew�hlt oder Auwahl entfernt wurde //

//get GET-Variablen
var url=window.location.href;
url=replaceSonderzeichen(url);
var GET_Variablen = url.split("?");
var GET_split = GET_Variablen[1].split("&");
var application = '';
var coordinates = '';
var scale = '';
var poi_srs = '';
var poi_label = '';
var firstLoad = '';
var mapbender = '';
for(var inc=0; inc<GET_split.length; inc++){
    var Splitflash= GET_split[inc].split("=");
    if(Splitflash[0]=='application'){
        application = Splitflash[1];
    }
    else if((Splitflash[0]=='poi_point') || (Splitflash[0]=='poi%5Bpoint%5D')){
        coordinates = Splitflash[1];
    }
    else if((Splitflash[0]=='poi_srs') || (Splitflash[0]=='poi%5Bsrs%5D')){
        poi_srs = Splitflash[1];
    }
    else if((Splitflash[0]=='poi_scale') || (Splitflash[0]=='poi%5Bscale%5D')){
        scale = Splitflash[1];
    }
    else if((Splitflash[0]=='poi_label')|| (Splitflash[0]=='poi%5Blabel%5D')){
        poi_label = Splitflash[1];
    }                                                                                             
    else if(Splitflash[0]=='firstLoad'){
        firstLoad = Splitflash[1];
    }
    else if(Splitflash[0]=='mapbender'){
        mapbender = Splitflash[1];
    }
}
    var mapbenderCross = url.split('#');
    if (mapbenderCross.length>1){
    //funktioniert nur, wenn die Mapbender-Daten am Ende der URL hinter dem letzten "#" sind
        document.getElementById("formStart").action+="&mapbender="+mapbenderCross[mapbenderCross.length-1];
//        console.log(document.getElementById("formStart").action);
    }


if (firstLoad=='false'){
    //Spezifikationen f�r Applikationen generell
        var XXXX = 384807;
        var YYYY = 5935654;
        var POIsollGesetztWerden=false;
        var zoomValue = 14;
        var point = '';
     
    if (coordinates!=""){
        point=coordinates.split(",");
        XXXX = parseInt(point[0]);
        YYYY = parseInt(point[1]);
        POIsollGesetztWerden=true;
    }         
    else if (mapbender!=""){
        var flash=mapbender.split("@");
        point = flash[1].split('r')[0].split('/');
        var pointTransform = transform([parseFloat(point[0]), parseFloat(point[1])], 'EPSG:4326', 'EPSG:25833');
      //center: ol.proj.transform([13.26, 53.55], 'EPSG:4326', 'EPSG:25833'),
        XXXX = parseInt(pointTransform[0]);
        YYYY = parseInt(pointTransform[1]);
        POIsollGesetztWerden=false;
        scale = flash[0];
    }         

    if (scale>1000){
        zoomValue= 16.75-(0.25*scale/2500);
    }
    else if (scale>0) {
        zoomValue= 23-(0.25*scale/200);
    }

        // ------- Beginn Applikationen Spezifikationen festlegen         
        //- alphabetisch, da genauso wie Mapbender-Applikationen mit Ausnahme der Applikationen, die zu dem selben Themengebiet geh�ren


//Badestrand
    if (application.localeCompare("Badestrand")==0){
        document.getElementById("LayerStrandCheck").checked = true;
        toggleJSLayerStrand(document.getElementById("LayerStrandCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
    }    

// Bauaufsichtsbezirke
    if (application.localeCompare("Bauaufsichtsbezirke")==0){
        document.getElementById("LayerBauaufsichtsbezirkeCheck").checked = true;
        toggleJSLayerBauaufsichtsbezirke(document.getElementById("LayerBauaufsichtsbezirkeCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
        zoomValue = 14;
    } 

//Baudenkmale + Baudenkmale_all
    if (application.localeCompare("Baudenkmale")==0){
        document.getElementById("LayerBaudenkmaleCheck").checked = true;
        toggleJSLayerBaudenkmale(document.getElementById("LayerBaudenkmaleCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    
    if (application.localeCompare("Baudenkmale_all")==0){
        document.getElementById("LayerBaudenkmaleCheck").checked = true;
        toggleJSLayerBaudenkmale(document.getElementById("LayerBaudenkmaleCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

// Bebauungsplaene + Bebauungsplaene_all + vorhabenbezogenen_B_Plan
    if (application.localeCompare("Bebauungsplaene")==0){
        document.getElementById("LayerBPlaeneCheck").checked = true;
        toggleJSLayerBPlaene(document.getElementById("LayerBPlaeneCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    
    if (application.localeCompare("Bebauungsplaene_all")==0){
        document.getElementById("LayerBPlaeneCheck").checked = true;
        toggleJSLayerBPlaene(document.getElementById("LayerBPlaeneCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    

    if (application.localeCompare("vorhabenbezogenen_B-Plan") == 0) {
        document.getElementById("LayerBPlaeneCheck").checked = true;
        toggleJSLayerBPlaene(document.getElementById("LayerBPlaeneCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");
    }    
    if (application.localeCompare("Bebauungsplaene_iA") == 0) {
        document.getElementById("LayerBPlaeneCheck").checked = true;
        toggleJSLayerBPlaene(document.getElementById("LayerBPlaeneCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");
    }    
//Bebauungsplaene_BPL
    if (application.localeCompare("Bebauungsplaene_all_Tif")==0){
        document.getElementById("LayerBPlaeneTifCheck").checked = true;
        toggleJSLayerBPlaeneTif(document.getElementById("LayerBPlaeneTifCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    
//City_WC
    if (application.localeCompare("City_WC")==0){
        document.getElementById("LayerCityWCCheck").checked = true;
        toggleJSLayerCityWC(document.getElementById("LayerCityWCCheck"), application);
        document.getElementById("Collapse4").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton4").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton4").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

//Denkmalbereiche
    if (application.localeCompare("Denkmalbereiche")==0){
        document.getElementById("LayerDenkmalbereicheCheck").checked = true;
        toggleJSLayerDenkmalbereiche(document.getElementById("LayerDenkmalbereicheCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 15;
        }
        if(coordinates==""){
            XXXX = 384807.39;
            YYYY = 5935114.15;
        }
    }    
    if ((application.localeCompare("Einzelhandelsstandorte")>=0)&&(application.localeCompare("EinzelhandelsstandorteZZZ")<0)){
        document.getElementById("LayerEinzelhandelCheck").checked = true;
        toggleJSLayerEinzelhandel(document.getElementById("LayerEinzelhandelCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    

//Einzelhandel + Einzelhandel_A + Einzelhandel_B + Einzelhandel_C + Einzelhandel_D + Einzelhandel_E + Einzelhandel_F 
    if ((application.localeCompare("Einzelhandelsstandorte")>=0)&&(application.localeCompare("EinzelhandelsstandorteZZZ")<0)){
        document.getElementById("LayerEinzelhandelCheck").checked = true;
        toggleJSLayerEinzelhandel(document.getElementById("LayerEinzelhandelCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    

//E-Ladestationen
    if (application.localeCompare("E-Ladestationen")==0){
        document.getElementById("LayerE_LadeCheck").checked = true;
        toggleJSLayerE_Lade(document.getElementById("LayerE_LadeCheck"), application);
        document.getElementById("Collapse4").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton4").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton4").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

// Erhaltungssatzungen
    if (application.localeCompare("Erhaltungssatzungen")==0){
        document.getElementById("LayerErhaltungssatzungenCheck").checked = true;
        toggleJSLayerErhaltungssatzungen(document.getElementById("LayerErhaltungssatzungenCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 16;
        }
    }
    
//Fahrgastschifffahrt
    if (application.localeCompare("Fahrgastschifffahrt")==0){
        document.getElementById("LayerSchiffCheck").checked = true;
        toggleJSLayerSchiff(document.getElementById("LayerSchiffCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 381175.39;
            YYYY = 5930173.15;
        }
        if(scale==""){
            zoomValue = 13.25;
        }
    }    

//Friedhoefe  + Waldfriedhof_Carlshoehe + Neuer_Friedhof + Friedhof_Weitin
    if (application.localeCompare("Friedhoefe")==0){
        document.getElementById("LayerFriedhofCheck").checked = true;
        toggleJSLayerFriedhof(document.getElementById("LayerFriedhofCheck"), application);
        document.getElementById("Collapse3").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton3").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton3").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 14.5;
        }
    }
    if (application.localeCompare("Waldfriedhof_Carlshoehe")==0){
        document.getElementById("LayerFriedhofCheck").checked = true;
        toggleJSLayerFriedhof(document.getElementById("LayerFriedhofCheck"), application);
        document.getElementById("Collapse3").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton3").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton3").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 388808.20;
            YYYY = 5933418.91;
        }
        if(scale==""){
            zoomValue = 18;
        }
    }    
    if (application.localeCompare("Neuer_Friedhof")==0){
        document.getElementById("LayerFriedhofCheck").checked = true;
        toggleJSLayerFriedhof(document.getElementById("LayerFriedhofCheck"), application);
        document.getElementById("Collapse3").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton3").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton3").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 386442.28;
            YYYY = 5935363.51;
        }
        if(scale==""){
            zoomValue = 17.5;
        }
    }    
    if (application.localeCompare("Friedhof_Weitin")==0){
        document.getElementById("LayerFriedhofCheck").checked = true;
        toggleJSLayerFriedhof(document.getElementById("LayerFriedhofCheck"), application);
        document.getElementById("Collapse3").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton3").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton3").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 381040.27;
            YYYY = 5936722.27;
        }
        if(scale==""){
            zoomValue = 19;
        }
    }    

//Fruehjahrsputz
    if ((application.localeCompare("Fruehjahrsputz")>=0)&&(application.localeCompare("FruehjahrsputzZZZ")<0)){
        document.getElementById("LayerFruehjahrsputzCheck").checked = true;
        toggleJSLayerFruehjahrsputz(document.getElementById("LayerFruehjahrsputzCheck"), application);
        document.getElementById("Collapse4").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton4").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton4").setAttribute("class", "collapse_mobile");  
    }    

// Gewerbe
    if (application.localeCompare("Gewerbeimmobilien")==0){
        document.getElementById("LayerGewerbeCheck").checked = true;
        toggleJSLayerGewerbe(document.getElementById("LayerGewerbeCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    

// Integration + Integration_Behoerden...
    if ((application.localeCompare("Integration")>=0)&&(application.localeCompare("IntegrationZZZ")<0)){
        document.getElementById("LayerIntegrationCheck").checked = true;
        toggleJSLayerIntegration(document.getElementById("LayerIntegrationCheck"), application);
        document.getElementById("Collapse3").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton3").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton3").setAttribute("class", "collapse_mobile");  
    }    

// Kunst + Kunst_all
    if (application.localeCompare("Kunst")==0){
        document.getElementById("LayerKunstCheck").checked = true;
        toggleJSLayerKunst(document.getElementById("LayerKunstCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    
    if (application.localeCompare("Kunst_all")==0){
        document.getElementById("LayerKunstCheck").checked = true;
        toggleJSLayerKunst(document.getElementById("LayerKunstCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 16.5;
        }
    }    

// Landschaftsgarten
    if (application.localeCompare("Landschaftsgarten")==0){
        document.getElementById("LayerLandschaftsgartenCheck").checked = true;
        toggleJSLayerLandschaftsgarten(document.getElementById("LayerLandschaftsgartenCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 382308.79;
            YYYY = 5935864.93;
        }
        if(scale==""){
            zoomValue = 17;
        }
    }    

// Mit_dem_Hund_unterwegs
    if (application.localeCompare("Mit_dem_Hund_unterwegs")==0){
        document.getElementById("LayerHundeCheck").checked = true;
        toggleJSLayerHunde(document.getElementById("LayerHundeCheck"), application);
        document.getElementById("Collapse3").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton3").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton3").setAttribute("class", "collapse_mobile");  
    }    

//P15_Parktickets
    if (application.localeCompare("P15_Parktickets")==0){
        document.getElementById("LayerP15Check").checked = true;
        toggleJSLayerP15(document.getElementById("LayerP15Check"), application);
        document.getElementById("Collapse4").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton4").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton4").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
//            XXXX = 384807.1710;
            YYYY = 5935054.2722; 
        }
        if(scale==""){
            zoomValue = 15;
        }
    }    

//Parkplatz
    if (application.localeCompare("Parkplatz")==0){
        document.getElementById("LayerParkplatzCheck").checked = true;
        toggleJSLayerParkplatz(document.getElementById("LayerParkplatzCheck"), application);
        document.getElementById("Collapse4").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton4").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton4").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 15;
        }
    }    

// Praehistorische_Plaetze
    if (application.localeCompare("Praehistorische_Plaetze")==0){
        document.getElementById("LayerHistoCheck").checked = true;
        toggleJSLayerHisto(document.getElementById("LayerHistoCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

//Radrundweg
    if (application.localeCompare("Radrundweg")==0){
        document.getElementById("LayerRadrundwegCheck").checked = true;
        toggleJSLayerRadrundweg(document.getElementById("LayerRadrundwegCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 381175.39;
            YYYY = 5930173.15;
        }
        if(scale==""){
            zoomValue = 14;
        }
    }    

//Schulen
    if (application.localeCompare("Schulen") == 0) {
        document.getElementById("LayerSchulenCheck").checked = true;
        toggleJSLayerSchulen(document.getElementById("LayerSchulenCheck"), application);
        document.getElementById("Collapse5").setAttribute("class", "collapse show");
        document.getElementById("CollapseButton5").setAttribute("aria-expanded", "true");
        document.getElementById("CollapseButton5").setAttribute("class", "collapse_mobile");
        if (scale == "") {
            zoomValue = 14.5;
        }
    }    
    if (application.localeCompare("Kitas") == 0) {
        document.getElementById("LayerKitasCheck").checked = true;
        toggleJSLayerKitas(document.getElementById("LayerKitasCheck"), application);
        document.getElementById("Collapse5").setAttribute("class", "collapse show");
        document.getElementById("CollapseButton5").setAttribute("aria-expanded", "true");
        document.getElementById("CollapseButton5").setAttribute("class", "collapse_mobile");
        if (scale == "") {
            zoomValue = 14.5;
        }
    }    

//Spielplaetze
    if (application.localeCompare("Spielplaetze")==0){
        document.getElementById("LayerSpielplaetzeCheck").checked = true;
        toggleJSLayerSpielplaetze(document.getElementById("LayerSpielplaetzeCheck"), application);
        document.getElementById("Collapse5").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton5").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton5").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 14.5;
        }
    }    

// Solarpotential
    if (application.localeCompare("Solarpotential_NB")==0){
        document.getElementById("LayerSolarpotentialCheck").checked = true;
        toggleJSLayerSolarpotential(document.getElementById("LayerSolarpotentialCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    

// Sportstaetten
    if (application.localeCompare("Sportstaetten")==0){
        document.getElementById("LayerSportplaetzeCheck").checked = true;
        toggleJSLayerSportplaetze(document.getElementById("LayerSportplaetzeCheck"), application);
        document.getElementById("Collapse5").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton5").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton5").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 14.5;
        }
    }    

//Spurensuche
    if (application.localeCompare("Spurensuche")==0){
        document.getElementById("LayerSpurensucheCheck").checked = true;
        toggleJSLayerSpurensuche(document.getElementById("LayerSpurensucheCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 384607.1710;
            YYYY = 5935454.2722;
        } 
        if(scale==""){
            zoomValue = 16.5;
        }
    }    

// Virtueller_Stadtrundgang + Stadtrundgang
    if (application.localeCompare("Stadtrundgang")==0){
        document.getElementById("LayerStadtrundgangCheck").checked = true;
        toggleJSLayerStadtrundgang(document.getElementById("LayerStadtrundgangCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

    if (application.localeCompare("Virtueller_Rundgang")==0){
        document.getElementById("LayerStadtrundgangCheck").checked = true;
        toggleJSLayerStadtrundgang(document.getElementById("LayerStadtrundgangCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

    if (application.localeCompare("Virtueller_Stadtrundgang")==0){
        document.getElementById("LayerStadtrundgangCheck").checked = true;
        toggleJSLayerStadtrundgang(document.getElementById("LayerStadtrundgangCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

// Standesamt
    if (application.localeCompare("Standesamt")==0){
        document.getElementById("LayerStandesamtCheck").checked = true;
        toggleJSLayerStandesamt(document.getElementById("LayerStandesamtCheck"), application);
        document.getElementById("Collapse3").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton3").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton3").setAttribute("class", "collapse_mobile");  
    }    

// Statistik
    if (application.localeCompare("Statistik")==0){
        document.getElementById("LayerStatistikCheck").checked = true;
        toggleJSLayerStatistik(document.getElementById("LayerStatistikCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
    }    

// Strassenreinigung
    if (application.localeCompare("Strassenreinigung")==0){
        document.getElementById("LayerReinigungCheck").checked = true;
        toggleJSLayerReinigung(document.getElementById("LayerReinigungCheck"), application);
        document.getElementById("Collapse4").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton4").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton4").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    

// Tollensesee
    if (application.localeCompare("Tollensesee")==0){
        document.getElementById("LayerTollenseseeCheck").checked = true;
        toggleJSLayerTollensesee(document.getElementById("LayerTollenseseeCheck"), application);
        document.getElementById("Collapse2").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton2").setAttribute("aria-expanded", "true");
        document.getElementById("CollapseButton2").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 381175.39;
            YYYY = 5930173.15;
        }
        if(scale==""){
            zoomValue = 13.25;
        }
    }    

// Trasse_Ortsumgehung
/*
    if (application.localeCompare("Trasse_Ortsumgehung")==0){
        document.getElementById("LayerOrtsumgehungCheck").checked = true;
        toggleJSLayerOrtsumgehung(document.getElementById("LayerOrtsumgehungCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");  
        if(coordinates==""){
            XXXX = 385755.61;
            YYYY = 5934715.89;
        }
        if(scale==""){
            zoomValue = 15;
        }
    }    
*/
//Wahllokale_2022
    if (application.localeCompare("Wahllokale_2022")==0){
        document.getElementById("LayerWahllokale_2022Check").checked = true;
        toggleJSLayerWahllokale_2022(document.getElementById("LayerWahllokale_2022Check"), application);
        document.getElementById("Collapse7").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton7").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton7").setAttribute("class", "collapse_mobile");  
        zoomValue = 14;
    } 

//Winterdienst
    if (application.localeCompare("Winterdienst")==0){
        document.getElementById("LayerWinterdienstCheck").checked = true;
        toggleJSLayerWinterdienst(document.getElementById("LayerWinterdienstCheck"), application);
        document.getElementById("Collapse4").setAttribute("class", "collapse show");  
        document.getElementById("CollapseButton4").setAttribute("aria-expanded", "true");  
        document.getElementById("CollapseButton4").setAttribute("class", "collapse_mobile");  
        if(scale==""){
            zoomValue = 17;
        }
    }    
    //Wohnungsbaustandorte
    if (application.localeCompare("Wohnungsbaustandorte") == 0) {
        document.getElementById("LayerWohnungsbauCheck").checked = true;
        toggleJSLayerWohnungsbau(document.getElementById("LayerWohnungsbauCheck"), application);
        document.getElementById("Collapse1").setAttribute("class", "collapse show");
        document.getElementById("CollapseButton1").setAttribute("aria-expanded", "true");
        document.getElementById("CollapseButton1").setAttribute("class", "collapse_mobile");
    }



        //toggleJSLayerDOP(document.getElementById("LayerDOPCheck"), application);
        //toggleJSLayerORKA(document.getElementById("LayerORKACheck"), application);
    toggleJSLayerOSM(document.getElementById("LayerOSMCheck"), application);

    
        // ------- Ende Applikationen Spezifikationen festlegen 
// -- Beginn von Aktivierung und Deaktivierung spezifische Layer

                                    /////////////////////////// Wirtschaft und Entwicklung ///////////////////////////

function toggleJSLayerWahllokale_2022(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getWahllokaleStandortFeatures();
            WahllokaleStandortVector.setVisible(false);
            WahllokaleStandortVector.setVisible(true);
            getWahllokaleNummerFeatures();
            WahllokaleNummerVector.setVisible(false);
            WahllokaleNummerVector.setVisible(true);
            getWahllokaleBezirkFeatures();
            WahllokaleBezirkVector.setVisible(false);
            WahllokaleBezirkVector.setVisible(true);
    }
    else {
            WahllokaleStandortVector.setVisible(false);
            WahllokaleBezirkVector.setVisible(false);
            WahllokaleNummerVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerBPlaene(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Bebauungsplaene')==0){
            getBPlaeneFeatures();
        }
        else if (application.localeCompare('vorhabenbezogenen_B-Plan')==0){
            getVBPlaeneFeatures();
        }
        else {
            getBPlaene_allFeatures();
        }
            BPlaeneVector.setVisible(false);
            BPlaeneVector.setVisible(true);

            VBPlaeneVector.setVisible(false);
            VBPlaeneVector.setVisible(true);
            BPlaeneUmringVector.setVisible(false);
            BPlaeneUmringVector.setVisible(true);
        BPlaeneAufstellungVector.setVisible(false);
        BPlaeneAufstellungVector.setVisible(true);

    }
    else {
            BPlaeneVector.setVisible(false);
            VBPlaeneVector.setVisible(false);
            BPlaeneUmringVector.setVisible(false);
        BPlaeneAufstellungVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}
function toggleJSLayerBPlaeneTif(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getBPlaeneTifFeatures(application);
            BPlaeneTifVector.setVisible(false);
            BPlaeneTifVector.setVisible(true);
            wmsLayerBPlaeneTif.setVisible(false);
            wmsLayerBPlaeneTif.setVisible(true);
    }
    else {
            BPlaeneTifVector.setVisible(false);
            wmsLayerBPlaeneTif.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerGewerbe(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getGewerbeFeatures();
            GewerbeVector.setVisible(false);
            GewerbeVector.setVisible(true);
    }
    else {
            GewerbeVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerStatistik(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStatistikAllFeatures();
            StatistikAllVector.setVisible(false);
            StatistikAllVector.setVisible(true);
            getStatistikStadtteileFeatures();
            StatistikStadtteileVector.setVisible(false);
            StatistikStadtteileVector.setVisible(true);
    }
    else {
            StatistikAllVector.setVisible(false);
            StatistikStadtteileVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerOrtsumgehung(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerOrtsumgehung.setVisible(true);
    }
    else {
            wmsLayerOrtsumgehung.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerEinzelhandel(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Einzelhandelsstandorte_A')==0){
            getEinzelhandel_AFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_B')==0){
            getEinzelhandel_BFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_C')==0){
            getEinzelhandel_CFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_D')==0){
            getEinzelhandel_DFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_E')==0){
            getEinzelhandel_EFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_F')==0){
            getEinzelhandel_FFeatures();
        }
        else {
            getEinzelhandelFeatures();
        }
            EinzelhandelVector.setVisible(false);
            EinzelhandelVector.setVisible(true);
    }
    else {
            EinzelhandelVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerErhaltungssatzungen(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getErhaltungssatzungenFeatures();
            ErhaltungssatzungenVector.setVisible(false);
            ErhaltungssatzungenVector.setVisible(true);
    }
    else {
            ErhaltungssatzungenVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerBauaufsichtsbezirke(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getBauaufsichtsbezirkeFeatures();
            BauaufsichtsbezirkeVector.setVisible(false);
            BauaufsichtsbezirkeVector.setVisible(true);
    }
    else {
            BauaufsichtsbezirkeVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

    function toggleJSLayerSolarpotential(element, application) {
        if (element.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
            getSolarpotentialFeatures();
            SolarpotentialVector.setVisible(false);
            SolarpotentialVector.setVisible(true);
        }
        else {
            SolarpotentialVector.setVisible(false);
        }

        toggleJSColoring(element, element.className);
    }

    function toggleJSLayerWohnungsbau(element, application) {
        if (element.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
            getWohnungsbauFeatures();
            WohnungsbauVector.setVisible(false);
            WohnungsbauVector.setVisible(true);
        }
        else {
            WohnungsbauVector.setVisible(false);
        }

        toggleJSColoring(element, element.className);
    }

                                    /////////////////////////// Kultur und Tourismus ///////////////////////////

function toggleJSLayerBaudenkmale(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Baudenkmale_all')==0){
            getBaudenkmaleAll2018Features();
            BaudenkmaleAll2018Vector.setVisible(false);
            BaudenkmaleAll2018Vector.setVisible(true);
            getBaudenkmaleAllNeuFeatures();
            BaudenkmaleAllNeuVector.setVisible(false);
            BaudenkmaleAllNeuVector.setVisible(true);
            getBaudenkmaleFlaechenFeatures();
            BaudenkmaleFlaechenVector.setVisible(false);
            BaudenkmaleFlaechenVector.setVisible(true);
        }
        else {
            getBaudenkmaleFeatures();
            BaudenkmaleVector.setVisible(false);
            BaudenkmaleVector.setVisible(true);
        }

    }
    else {
            BaudenkmaleVector.setVisible(false);
            BaudenkmaleFlaechenVector.setVisible(false);
            BaudenkmaleAll2018Vector.setVisible(false);
            BaudenkmaleAllNeuVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerDenkmalbereiche(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getDenkmalbereicheFeatures();
            DenkmalbereicheVector.setVisible(false);
            DenkmalbereicheVector.setVisible(true);
    }
    else {
            DenkmalbereicheVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerKunst(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Kunst_all')==0){
            getKunstAllFeatures();
            KunstAllVector.setVisible(false);
            KunstAllVector.setVisible(true);
        }
        else {
            getKunstFeatures();
            KunstVector.setVisible(false);
            KunstVector.setVisible(true);
        }
    }
    else {
            KunstVector.setVisible(false);
            KunstAllVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerHisto(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getHistoFeatures();
            HistoVector.setVisible(false);
            HistoVector.setVisible(true);
    }
    else {
            HistoVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerTollensesee(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getTollenseseeFeatures();
            TollenseseeVector.setVisible(false);
            TollenseseeVector.setVisible(true);
    }
    else {
            TollenseseeVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerSchiff(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSchiffFeatures();
            SchiffVector.setVisible(false);
            SchiffVector.setVisible(true);
    }
    else {
            SchiffVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerStrand(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStrandFeatures();
            StrandVector.setVisible(false);
            StrandVector.setVisible(true);
            getStrandAugustabadFeatures();
            StrandAugustabadVector.setVisible(false);
            StrandAugustabadVector.setVisible(true);
            getStrandBrodaFeatures();
            StrandBrodaVector.setVisible(false);
            StrandBrodaVector.setVisible(true);
    }
    else {
            StrandVector.setVisible(false);
            StrandAugustabadVector.setVisible(false);
            StrandBrodaVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerStadtrundgang(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStadtrundgangFeatures();
            StadtrundgangVector.setVisible(false);
            StadtrundgangVector.setVisible(true);
    }
    else {
            StadtrundgangVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerLandschaftsgarten(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerLandschaftsgarten.setVisible(true);
            getLandschaftsgartenFeatures();
            LandschaftsgartenVector.setVisible(false);
            LandschaftsgartenVector.setVisible(true);
    }
    else {
            wmsLayerLandschaftsgarten.setVisible(false);
            LandschaftsgartenVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerRadrundweg(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerRadrundweg.setVisible(true);
    }
    else {
            wmsLayerRadrundweg.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerSpurensuche(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSpurensucheFeatures();
            SpurensucheVector.setVisible(false);
            SpurensucheVector.setVisible(true);
    }
    else {
            SpurensucheVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerE_Lade(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getE_LadeFeatures();
            E_LadeVector.setVisible(false);
            E_LadeVector.setVisible(true);
    }
    else {
            E_LadeVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}


                                    /////////////////////////// Leben und Wohnen ///////////////////////////

function toggleJSLayerStandesamt(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStandesamtFeatures();
            StandesamtVector.setVisible(false);
            StandesamtVector.setVisible(true);
    }
    else {
            StandesamtVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerFriedhof(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getFriedhofFeatures();
            FriedhofVector.setVisible(false);
            FriedhofVector.setVisible(true);
    }
    else {
            FriedhofVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerIntegration(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Integration_Behoerden')==0){
            getIntegration_BehoerdenFeatures();
        }
        else if (application.localeCompare('Integration_Beratung')==0){
            getIntegration_BeratungFeatures();
        }
        else if (application.localeCompare('Integration_Betreuung')==0){
            getIntegration_BetreuungFeatures();
        }
        else if (application.localeCompare('Integration_Bildungseinrichtungen')==0){
            getIntegration_BildungseinrichtungenFeatures();
        }
        else if (application.localeCompare('Integration_Freizeitangebote')==0){
            getIntegration_FreizeitangeboteFeatures();
        }
        else if (application.localeCompare('Integration_Wohnen')==0){
            getIntegration_WohnenFeatures();
        }
        else {
            getIntegrationFeatures();
        }
            IntegrationVector.setVisible(false);
            IntegrationVector.setVisible(true);
    }
    else {
            IntegrationVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerHunde(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getHundeFeatures();
            HundeVector.setVisible(false);
            HundeVector.setVisible(true);
            getHundeAlleFeatures();
            HundeAlleVector.setVisible(false);
            HundeAlleVector.setVisible(true);
            getHunde40cmFeatures();
            Hunde40cmVector.setVisible(false);
            Hunde40cmVector.setVisible(true);
            getHundeTuetenFeatures();
            HundeTuetenVector.setVisible(false);
            HundeTuetenVector.setVisible(true);
            getHundeStrandFeatures();
            HundeStrandVector.setVisible(false);
            HundeStrandVector.setVisible(true);
            getHundeZeitFeatures();
            HundeZeitVector.setVisible(false);
            HundeZeitVector.setVisible(true);
    }
    else {
            HundeVector.setVisible(false);
            HundeAlleVector.setVisible(false);
            Hunde40cmVector.setVisible(false);
            HundeTuetenVector.setVisible(false);
            HundeStrandVector.setVisible(false);
            HundeZeitVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

                                    /////////////////////////// Sicherheit und Ordnung ///////////////////////////

function toggleJSLayerCityWC(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getCityWCFeatures();
            CityWCVector.setVisible(false);
            CityWCVector.setVisible(true);
    }
    else {
            CityWCVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerReinigung(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getReinigungFeatures();
            ReinigungVector.setVisible(false);
            ReinigungVector.setVisible(true);
    }
    else {
            ReinigungVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerWinterdienst(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getWinterdienst1Features();
            Winterdienst1Vector.setVisible(false);
            Winterdienst1Vector.setVisible(true);
            getWinterdienst2Features();
            Winterdienst2Vector.setVisible(false);
            Winterdienst2Vector.setVisible(true);
    }
    else {
            Winterdienst2Vector.setVisible(false);
            Winterdienst1Vector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerParkplatz(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getParkplatzParkFeatures();
            ParkplatzParkVector.setVisible(false);
            ParkplatzParkVector.setVisible(true);
            getParkplatzBusFeatures();
            ParkplatzBusVector.setVisible(false);
            ParkplatzBusVector.setVisible(true);
            getParkplatzLKWFeatures();
            ParkplatzLKWVector.setVisible(false);
            ParkplatzLKWVector.setVisible(true);
    }
    else {
            ParkplatzParkVector.setVisible(false);
            ParkplatzBusVector.setVisible(false);
            ParkplatzLKWVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerP15(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getP15Features();
            P15Vector.setVisible(false);
            P15Vector.setVisible(true);
    }
    else {
            P15Vector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerFruehjahrsputz(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getFruehjahrsputzFeatures();
            FruehjahrsputzVector.setVisible(false);
            FruehjahrsputzVector.setVisible(true);
    }
    else {
            FruehjahrsputzVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}


                                    /////////////////////////// Bildung und Sport ///////////////////////////

    function toggleJSLayerSchulen(element, application) {
        if (element.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
            getSchulenFeatures();
            SchulenVector.setVisible(false);
            SchulenVector.setVisible(true);
        }
        else {
            SchulenVector.setVisible(false);
        }

        toggleJSColoring(element, element.className);
    }

    function toggleJSLayerKitas(element, application) {
        if (element.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
            getKitasFeatures();
            KitasVector.setVisible(false);
            KitasVector.setVisible(true);
        }
        else {
            KitasVector.setVisible(false);
        }

        toggleJSColoring(element, element.className);
    }

function toggleJSLayerSportplaetze(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSportplaetzeFeatures();
            SportplaetzeVector.setVisible(false);
            SportplaetzeVector.setVisible(true);
    }
    else {
            SportplaetzeVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerSpielplaetze(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSpielplaetzeFeatures();
            SpielplaetzeVector.setVisible(false);
            SpielplaetzeVector.setVisible(true);
    }
    else {
            SpielplaetzeVector.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}



                                    /////////////////////////// Umwelt ///////////////////////////

function toggleJSLayerMVSchutz(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerMVSchutz.setVisible(true);
    }
    else {
            wmsLayerMVSchutz.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}


                                    /////////////////////////// Weitere Karten ///////////////////////////

function toggleJSLayerKommunFl(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerKommunFl.setVisible(true);
    }
    else {
            wmsLayerKommunFl.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerStadtkarte(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerStadtkarte.setVisible(true);
    }
    else {
            wmsLayerStadtkarte.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerUebersichtskarte(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerUebersichtskarte.setVisible(true);
    }
    else {
            wmsLayerUebersichtskarte.setVisible(false);
    }
    
    toggleJSColoring(element, element.className);
}

function toggleJSLayerDOP(element, application){
    if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerORKA.setVisible(false);
            wmsLayerDOP.setVisible(true);
            toggleJSColoring(document.getElementById("LayerORKACheck"), "btn btn-primary btn-rounded btn-block my-2");
    }
    
    toggleJSColoring(element, element.className);
}

    function toggleJSLayerORKA(element, application) {
        if (element.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
            wmsLayerORKA.setVisible(true);
            wmsLayerDOP.setVisible(false);
            toggleJSColoring(document.getElementById("LayerDOPCheck"), "btn btn-primary btn-rounded btn-block my-2");
        }

        toggleJSColoring(element, element.className);
    }
    function toggleJSLayerOSM(element, application) {
        if (element.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
            wmsLayerOSM.setVisible(true);
            OSMWmsLayer.setVisible(true);
            console.log('Layerdisabled');
        }
        else { //*** else not needed?*/
            wmsLayerOSM.setVisible(false);
            OSMWmsLayer.setVisible(false);
            console.log('Layerenabled');
        }

        toggleJSColoring(element, element.className);
    }

function toggleJSColoring(element, Klasse){
    if (Klasse.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            element.className="btn btn-primary btn-rounded btn-block my-2";
    }
    else {
            element.className="btn btn-info btn-rounded btn-block my-2";
    }
    element.blur();         
}

function toggleJSTrack(element){
        if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
               geolocation.setTracking(true);
               positionLayer.setVisible(true);
        }
        else {
               geolocation.setTracking(false);
               positionLayer.setVisible(false);
        }
}

// -- Ende von Aktivierung und Deaktivierung spezifische Layer


    var POIFeature = new Feature({
        geometry: new Point([XXXX, YYYY])
    });
    var colorFill = "rgba(255, 255, 255, 0)"; 
    var colorStroke = "rgba(0, 0, 0, 0)"; 
    var lineDashArray = [5, 0];
    var radiusPOI = 10; 
    var fontPOI = "bold 25px Calibri"; 
    var colorText = "rgba(0, 0, 0, 1)"; 
    var colorTextfield = "rgba(255, 255, 255, 0.8)"; 
    var strokeTextfield = "rgba(0, 0, 0, 1)";

    if (POIsollGesetztWerden){                             //es existiert keine POI_Funktion
        colorFill = "rgba(255, 255, 255, 0.5)"; 
        colorStroke = "rgba(0, 0, 0, 1)"; 
    }

    POIVector.setStyle(pointStyleFunction(poi_label, colorFill, colorStroke, colorText, radiusPOI, fontPOI, colorTextfield, strokeTextfield));

    if (coordinates!=""){
        POISource.addFeature(POIFeature);
        POIVector.setVisible(false);
        POIVector.setVisible(true);
    }
    //lege view fest
    changeCenter(XXXX, YYYY, zoomValue);
}


function pointStyleFunction(label, colorFill, colorStroke, colorText, radiusPOI, fontPOI, colorTextfield, strokeTextfield, feature, resolution){
    return new Style({
          fill: new Fill({
            color: colorFill
          }),
          stroke: new Stroke({
            color: colorStroke,
            width: 2
          }),
          image: new CircleStyle({
            radius: radiusPOI,
            fill: new Fill({
              color: colorFill
            }),
            stroke: new Stroke({
              color: colorStroke,
              width: 2
            })
          }),
          text: new TextStyle({
            font: fontPOI,
            textAlign: 'left',
            offsetX: 15,
            offsetY: -25,
            fill: new Fill({
                color: colorText
            }),
            backgroundFill: new Fill({
                color: colorTextfield
            }),
            backgroundStroke: new Stroke({
                color: strokeTextfield,
                width: 2
            }),
            padding: [5,5,5,5],
            //stroke: new Stroke({color: 'rgba(255,255,255,1)', width: 10}),
            text: label
        })
    });         
}

function changeCenter(XXXX, YYYY, zoomValue){
  var XX = parseInt(XXXX);
  var YY = parseInt(YYYY);
  view.animate({
      //center: ol.proj.transform([13.26, 53.55], 'EPSG:4326', 'EPSG:25833'),
      center: [XX, YY],
      zoom: zoomValue,
      projection: 'EPSG:25833',
      duration: 0
  });
}


// -- Beginn Funktionen f�r die Suche nach Hausnummern //
//SearchEventListener
var onClickOpenSearch = document.querySelector("a[id=OpenSearch]");
onClickOpenSearch.addEventListener('click', function() {
    OpenSearch();
});

function OpenSearch(){
    document.getElementById("SearchBody").innerHTML =
    '<button id="CollapseButtonSearch" style="width:100%; text-align:left;" data-toggle="collapse" data-target="#CollapseSearch" class="collapse_mobile collapsed" onclick="this.blur()" aria-expanded="false">Stra&szlig;en- und Hausnummernsuche (gewidmete Verkehrsfl&auml;chen)</button>' +
    '<div id="CollapseSearch" class="collapse">'+
    '        <button id="" type="button" class="btn btn-info btn-rounded btn-block my-2" onclick="switchSearch(1)">Stra&szlig;en- und Hausnummernsuche (gewidmete Verkehrsfl&auml;chen)</button>'+
    '        <button id="" type="button" class="btn btn-info btn-rounded btn-block my-2" onclick="switchSearch(2)">Stra&szlig;en- und Hausnummernsuche (Privatstra&szlig;en)</button>'+
    '        <button id="" type="button" class="btn btn-info btn-rounded btn-block my-2" onclick="switchSearch(3)">Wege- und Platzsuche (Wege und Pl&auml;tze ohne Widmung)</button>'+
    '</div>'+
    '<input type="text" id="Strasse" name="Strasse" placeholder="Stra&szlig;e"'+ 
        'onkeyup="completeStrasse()" autocomplete="off" list="StrasseList"'+
        'style="margin-bottom:30px; margin-top:30px;">'+
        '<datalist id="StrasseList">'+
        '</datalist>'+
    '<input type="text" id="Nummer" name="Nummer" placeholder="Hausnummer"'+ 
        'autocomplete="off"'+
        'style="margin-bottom:30px">'+
    '<input type="hidden" id="HausNummernContainer"><br>'+
    '<button id="Hausnummernsuche" name="Hausnummernsuche" class="btn btn_blue" style="">'+
        'Suchen'+
    '</button>'+
    '<div id="SearchResult">'+
    '</div>'+
    '';
//    document.getElementById("SearchFooter").innerHTML=
//        '<button type="button" class="btn btn-success mr-auto" data-dismiss="modal" id="SearchClose">Zur&uuml;ck</button>';
    document.getElementById("SearchHeader").innerHTML=
          '<h1 class="modal-title">Suchen</h1>'+
          '<button type="button" class="close" data-dismiss="modal" id="TemplateClose" style="font-size:27px; border-radius:50%; height:60px; width:60px; color:white; background-color:rgba(255,0,0,1);">X</button>';
    var srch__tkn = document.getElementById("srch__tkn").value;
    $.ajax({
        url:"../../lib7/functions/suchen/getHausnummern_gewidmet.php",
        type:"POST",
        data: {srch__tkn: srch__tkn},
        contentType: "application/x-www-form-urlencoded;charset=utf-8",
        success:function(result){
            document.getElementById("HausNummernContainer").value = (result);
        }
    });
    $('#SearchModal').modal();

    var onClickHausnummernsuche = document.querySelector("button[id=Hausnummernsuche]");
    onClickHausnummernsuche.addEventListener('click', function() {
        Hausnummernsuche();
    });

}

function Hausnummernsuche(){
    document.getElementById("SearchResult").innerHTML = '';
    HausnummerSource.clear();
    var HNRlist = [];
    var coordinatesPnt = [];
    var Strasse = document.getElementById("Strasse").value;
    var Nummer = document.getElementById("Nummer").value;
    var HausNummernListe = JSON.parse(document.getElementById("HausNummernContainer").value);
    var onClickSearchArray = [];
    for (var inc=0; inc < HausNummernListe.length; inc++){
        if (Strasse.localeCompare(HausNummernListe[inc][1]) == 0){
            if ((Nummer.localeCompare("") == 0) || (Nummer.localeCompare(HausNummernListe[inc][2]) == 0)) {
                HNRlist.push(HausNummernListe[inc]);
                coordinatesPnt[0]=parseFloat(HausNummernListe[inc][3]);
                coordinatesPnt[1]=parseFloat(HausNummernListe[inc][4]);
                var NrFeature = new Feature({
                    geometry: new Point(coordinatesPnt)
                });
                NrFeature.setId(inc);
                HausnummerSource.addFeature(NrFeature);
                
                document.getElementById("SearchResult").innerHTML +=
                '<a id="goToHouse_'+ coordinatesPnt[0] + '_' + coordinatesPnt[1] + '_' + inc +'" class="toPointer" '+ 
//                'onclick=goToHouse('+ coordinatesPnt[0] + ',' + coordinatesPnt[1] + ',' + inc +')'+
                '>'+
                HausNummernListe[inc][1]+ ' ' + HausNummernListe[inc][2]+
                '</a><br>'+ 
                '';
                
            }                                                                  
        }
    }
            
      //https://davidwalsh.name/event-delegate
      // Get the element, add a click listener...
      document.getElementById("SearchResult").addEventListener("click", function(e) {
      	// e.target is the clicked element!
      	// If it was an item of the specific type (muss gro� geschrieben werden)
      	if(e.target && e.target.nodeName == "A") {
      		//item found!  Output the ID!
      		//console.log("List item ", e.target.id.replace("post-", ""), " was clicked!");
            goToHouseId(e.target.id.replace("post-", ""));
      	}
      });

}
function goToHouseId(idString){
        var idArray=idString.split("_");
        var XXXX=idArray[1];
        var YYYY=idArray[2];
        var ID=idArray[3];
         changeCenter(XXXX,YYYY,19);
         document.getElementById("SearchResult").innerHTML = '';
         $('#SearchModal').modal('hide');
         var chosenStyle = new Style({
          fill: new Fill({
            color: 'rgba(204, 0, 0, 0.5)'
          }),
          stroke: new Stroke({
            color: 'rgba(102, 0, 0, 1)',
            width: 2
          }),
          image: new CircleStyle({
            radius: 10,
            fill: new Fill({
              color: 'rgba(0, 0, 255, 0.5)'
            }),
            stroke: new Stroke({
              color: 'rgba(0, 0, 255, 1)',
              width: 2
            })
          })
        })
        HausnummerSource.getFeatureById(ID).setStyle(chosenStyle);
}


//function completeStrasse() in index.html
// -- Ende Funktionen f�r die Suche nach Hausnummern //

                                    ///// --- Beginn Toggle Event Listener --- /////

                                    /////////////////////////// Wirtschaft und Entwicklung ///////////////////////////

            if (application=='Wahllokale_2022'){
var checkboxLayerWahllokale_2022Check = document.querySelector("button[id=LayerWahllokale_2022Check]");
checkboxLayerWahllokale_2022Check.addEventListener('click', function() {
    if(checkboxLayerWahllokale_2022Check.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getWahllokaleStandortFeatures();
            WahllokaleStandortVector.setVisible(false);
            WahllokaleStandortVector.setVisible(true);
            getWahllokaleNummerFeatures();
            WahllokaleNummerVector.setVisible(false);
            WahllokaleNummerVector.setVisible(true);
            getWahllokaleBezirkFeatures();
            WahllokaleBezirkVector.setVisible(false);
            WahllokaleBezirkVector.setVisible(true);
    }
    else {
            WahllokaleStandortVector.setVisible(false);
            WahllokaleBezirkVector.setVisible(false);
            WahllokaleNummerVector.setVisible(false);
    }
    
        toggleColoring(checkboxLayerWahllokale_2022Check, checkboxLayerWahllokale_2022Check.className);
});
            }

var checkboxLayerBPlaeneCheck = document.querySelector("button[id=LayerBPlaeneCheck]");
checkboxLayerBPlaeneCheck.addEventListener('click', function() {
    if(checkboxLayerBPlaeneCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Bebauungsplaene')==0){
            getBPlaeneFeatures();
        }
        else if (application.localeCompare('vorhabenbezogenen_B-Plan')==0){
            getVBPlaeneFeatures();
        }
        else {
            getBPlaene_allFeatures();
        }
            BPlaeneVector.setVisible(false);
            BPlaeneVector.setVisible(true);

            VBPlaeneVector.setVisible(false);
            VBPlaeneVector.setVisible(true);
            BPlaeneUmringVector.setVisible(false);
            BPlaeneUmringVector.setVisible(true);

        BPlaeneAufstellungVector.setVisible(false);
        BPlaeneAufstellungVector.setVisible(true);
    }
    else {
            BPlaeneVector.setVisible(false);
            VBPlaeneVector.setVisible(false);
            BPlaeneUmringVector.setVisible(false);
        BPlaeneAufstellungVector.setVisible(false);
    }
    
        toggleColoring(checkboxLayerBPlaeneCheck, checkboxLayerBPlaeneCheck.className);
});

    if (application.localeCompare("Bebauungsplaene_all_Tif")==0){
var checkboxLayerBPlaeneTifCheck = document.querySelector("button[id=LayerBPlaeneTifCheck]");
checkboxLayerBPlaeneTifCheck.addEventListener('click', function() {
    if(checkboxLayerBPlaeneTifCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getBPlaeneTifFeatures(application);
            BPlaeneTifVector.setVisible(false);
            BPlaeneTifVector.setVisible(true);
            wmsLayerBPlaeneTif.setVisible(false);
            wmsLayerBPlaeneTif.setVisible(true);
    }
    else {
            BPlaeneTifVector.setVisible(false);
            wmsLayerBPlaeneTif.setVisible(false);
    }
    
        toggleColoring(checkboxLayerBPlaeneTifCheck, checkboxLayerBPlaeneTifCheck.className);
});
    }

var checkboxLayerGewerbeCheck = document.querySelector("button[id=LayerGewerbeCheck]");
checkboxLayerGewerbeCheck.addEventListener('click', function() {
    if(checkboxLayerGewerbeCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getGewerbeFeatures();
            GewerbeVector.setVisible(false);
            GewerbeVector.setVisible(true);
    }
    else {
            GewerbeVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerGewerbeCheck, checkboxLayerGewerbeCheck.className);
});

var checkboxLayerStatistikCheck = document.querySelector("button[id=LayerStatistikCheck]");
checkboxLayerStatistikCheck.addEventListener('click', function() {
    if(checkboxLayerStatistikCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStatistikAllFeatures();
            StatistikAllVector.setVisible(false);
            StatistikAllVector.setVisible(true);
            getStatistikStadtteileFeatures();
            StatistikStadtteileVector.setVisible(false);
            StatistikStadtteileVector.setVisible(true);
    }
    else {
            StatistikAllVector.setVisible(false);
            StatistikStadtteileVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerStatistikCheck, checkboxLayerStatistikCheck.className);
});

/*
var checkboxLayerOrtsumgehungCheck = document.querySelector("button[id=LayerOrtsumgehungCheck]");
checkboxLayerOrtsumgehungCheck.addEventListener('click', function() {
    if(checkboxLayerOrtsumgehungCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerOrtsumgehung.setVisible(true);
    }
    else {
            wmsLayerOrtsumgehung.setVisible(false);
    }
    
    toggleColoring(checkboxLayerOrtsumgehungCheck, checkboxLayerOrtsumgehungCheck.className);
});
*/
var checkboxLayerEinzelhandelCheck = document.querySelector("button[id=LayerEinzelhandelCheck]");
checkboxLayerEinzelhandelCheck.addEventListener('click', function() {
    if(checkboxLayerEinzelhandelCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Einzelhandelsstandorte_A')==0){
            getEinzelhandel_AFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_B')==0){
            getEinzelhandel_BFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_C')==0){
            getEinzelhandel_CFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_D')==0){
            getEinzelhandel_DFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_E')==0){
            getEinzelhandel_EFeatures();
        }
        else if (application.localeCompare('Einzelhandelsstandorte_F')==0){
            getEinzelhandel_FFeatures();
        }
        else {
            getEinzelhandelFeatures();
        }
            EinzelhandelVector.setVisible(false);
            EinzelhandelVector.setVisible(true);
    }
    else {
            EinzelhandelVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerEinzelhandelCheck, checkboxLayerEinzelhandelCheck.className);
});

//            if (application=='Erhaltungssatzungen'){
var checkboxLayerErhaltungssatzungenCheck = document.querySelector("button[id=LayerErhaltungssatzungenCheck]");
checkboxLayerErhaltungssatzungenCheck.addEventListener('click', function() {
    if(checkboxLayerErhaltungssatzungenCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getErhaltungssatzungenFeatures();
            ErhaltungssatzungenVector.setVisible(false);
            ErhaltungssatzungenVector.setVisible(true);
    }
    else {
            ErhaltungssatzungenVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerErhaltungssatzungenCheck, checkboxLayerErhaltungssatzungenCheck.className);
});
//            }
            if (application=='Bauaufsichtsbezirke'){
var checkboxLayerBauaufsichtsbezirkeCheck = document.querySelector("button[id=LayerBauaufsichtsbezirkeCheck]");
checkboxLayerBauaufsichtsbezirkeCheck.addEventListener('click', function() {
    if(checkboxLayerBauaufsichtsbezirkeCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getBauaufsichtsbezirkeFeatures();
            BauaufsichtsbezirkeVector.setVisible(false);
            BauaufsichtsbezirkeVector.setVisible(true);
    }
    else {
            BauaufsichtsbezirkeVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerBauaufsichtsbezirkeCheck, checkboxLayerBauaufsichtsbezirkeCheck.className);
});
            }

var checkboxLayerSolarpotentialCheck = document.querySelector("button[id=LayerSolarpotentialCheck]");
checkboxLayerSolarpotentialCheck.addEventListener('click', function () {
    if (checkboxLayerSolarpotentialCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
        getSolarpotentialFeatures();
        SolarpotentialVector.setVisible(false);
        SolarpotentialVector.setVisible(true);
    }
    else {
        SolarpotentialVector.setVisible(false);
    }

    toggleColoring(checkboxLayerSolarpotentialCheck, checkboxLayerSolarpotentialCheck.className);
});

                if (application == 'Wohnungsbaustandorte') {
var checkboxLayerWohnungsbauCheck = document.querySelector("button[id=LayerWohnungsbauCheck]");
checkboxLayerWohnungsbauCheck.addEventListener('click', function () {
    if (checkboxLayerWohnungsbauCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
        getWohnungsbauFeatures();
        WohnungsbauVector.setVisible(false);
        WohnungsbauVector.setVisible(true);
    }
    else {
        WohnungsbauVector.setVisible(false);
    }

    toggleColoring(checkboxLayerWohnungsbauCheck, checkboxLayerWohnungsbauCheck.className);
});
                }
                                    /////////////////////////// Kultur und Tourismus ///////////////////////////

var checkboxLayerBaudenkmaleCheck = document.querySelector("button[id=LayerBaudenkmaleCheck]");
checkboxLayerBaudenkmaleCheck.addEventListener('click', function() {
    if(checkboxLayerBaudenkmaleCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Baudenkmale_all')==0){
            getBaudenkmaleAll2018Features();
            BaudenkmaleAll2018Vector.setVisible(false);
            BaudenkmaleAll2018Vector.setVisible(true);
            getBaudenkmaleAllNeuFeatures();
            BaudenkmaleAllNeuVector.setVisible(false);
            BaudenkmaleAllNeuVector.setVisible(true);
        }
        else {
            getBaudenkmaleFeatures();
            BaudenkmaleVector.setVisible(false);
            BaudenkmaleVector.setVisible(true);
        }

    }
    else {
            BaudenkmaleVector.setVisible(false);
            BaudenkmaleAll2018Vector.setVisible(false);
            BaudenkmaleAllNeuVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerBaudenkmaleCheck, checkboxLayerBaudenkmaleCheck.className);
});

var checkboxLayerDenkmalbereicheCheck = document.querySelector("button[id=LayerDenkmalbereicheCheck]");
checkboxLayerDenkmalbereicheCheck.addEventListener('click', function() {
    if(checkboxLayerDenkmalbereicheCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getDenkmalbereicheFeatures();
            DenkmalbereicheVector.setVisible(false);
            DenkmalbereicheVector.setVisible(true);
    }
    else {
            DenkmalbereicheVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerDenkmalbereicheCheck, checkboxLayerDenkmalbereicheCheck.className);
});

var checkboxLayerKunstCheck = document.querySelector("button[id=LayerKunstCheck]");
checkboxLayerKunstCheck.addEventListener('click', function() {
    if(checkboxLayerKunstCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Kunst_all')==0){
            getKunstAllFeatures();
            KunstAllVector.setVisible(false);
            KunstAllVector.setVisible(true);
        }
        else {
            getKunstFeatures();
            KunstVector.setVisible(false);
            KunstVector.setVisible(true);
        }
    }
    else {
            KunstVector.setVisible(false);
            KunstAllVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerKunstCheck, checkboxLayerKunstCheck.className);
});

var checkboxLayerHistoCheck = document.querySelector("button[id=LayerHistoCheck]");
checkboxLayerHistoCheck.addEventListener('click', function() {
    if(checkboxLayerHistoCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getHistoFeatures();
            HistoVector.setVisible(false);
            HistoVector.setVisible(true);
    }
    else {
            HistoVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerHistoCheck, checkboxLayerHistoCheck.className);
});

var checkboxLayerTollenseseeCheck = document.querySelector("button[id=LayerTollenseseeCheck]");
checkboxLayerTollenseseeCheck.addEventListener('click', function() {
    if(checkboxLayerTollenseseeCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getTollenseseeFeatures();
            TollenseseeVector.setVisible(false);
            TollenseseeVector.setVisible(true);
    }
    else {
            TollenseseeVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerTollenseseeCheck, checkboxLayerTollenseseeCheck.className);
});

var checkboxLayerSchiffCheck = document.querySelector("button[id=LayerSchiffCheck]");
checkboxLayerSchiffCheck.addEventListener('click', function() {
    if(checkboxLayerSchiffCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSchiffFeatures();
            SchiffVector.setVisible(false);
            SchiffVector.setVisible(true);
    }
    else {
            SchiffVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerSchiffCheck, checkboxLayerSchiffCheck.className);
});

var checkboxLayerStrandCheck = document.querySelector("button[id=LayerStrandCheck]");
checkboxLayerStrandCheck.addEventListener('click', function() {
    if(checkboxLayerStrandCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStrandFeatures();
            StrandVector.setVisible(false);
            StrandVector.setVisible(true);
            getStrandAugustabadFeatures();
            StrandAugustabadVector.setVisible(false);
            StrandAugustabadVector.setVisible(true);
            getStrandBrodaFeatures();
            StrandBrodaVector.setVisible(false);
            StrandBrodaVector.setVisible(true);
    }
    else {
            StrandVector.setVisible(false);
            StrandAugustabadVector.setVisible(false);
            StrandBrodaVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerStrandCheck, checkboxLayerStrandCheck.className);
});

var checkboxLayerStadtrundgangCheck = document.querySelector("button[id=LayerStadtrundgangCheck]");
checkboxLayerStadtrundgangCheck.addEventListener('click', function() {
    if(checkboxLayerStadtrundgangCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStadtrundgangFeatures();
            StadtrundgangVector.setVisible(false);
            StadtrundgangVector.setVisible(true);
    }
    else {
            StadtrundgangVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerStadtrundgangCheck, checkboxLayerStadtrundgangCheck.className);
});

var checkboxLayerLandschaftsgartenCheck = document.querySelector("button[id=LayerLandschaftsgartenCheck]");
checkboxLayerLandschaftsgartenCheck.addEventListener('click', function() {
    if(checkboxLayerLandschaftsgartenCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerLandschaftsgarten.setVisible(true);
            getLandschaftsgartenFeatures();
            LandschaftsgartenVector.setVisible(false);
            LandschaftsgartenVector.setVisible(true);
    }
    else {
            wmsLayerLandschaftsgarten.setVisible(false);
            LandschaftsgartenVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerLandschaftsgartenCheck, checkboxLayerLandschaftsgartenCheck.className);
});

var checkboxLayerRadrundwegCheck = document.querySelector("button[id=LayerRadrundwegCheck]");
checkboxLayerRadrundwegCheck.addEventListener('click', function() {
    if(checkboxLayerRadrundwegCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerRadrundweg.setVisible(true);
    }
    else {
            wmsLayerRadrundweg.setVisible(false);
    }
    
    toggleColoring(checkboxLayerRadrundwegCheck, checkboxLayerRadrundwegCheck.className);
});

//            if (application=='Spurensuche'){
var checkboxLayerSpurensucheCheck = document.querySelector("button[id=LayerSpurensucheCheck]");
checkboxLayerSpurensucheCheck.addEventListener('click', function() {
    if(checkboxLayerSpurensucheCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSpurensucheFeatures();
            SpurensucheVector.setVisible(false);
            SpurensucheVector.setVisible(true);
    }
    else {
            SpurensucheVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerSpurensucheCheck, checkboxLayerSpurensucheCheck.className);
});
//            }

var checkboxLayerE_LadeCheck = document.querySelector("button[id=LayerE_LadeCheck]");
checkboxLayerE_LadeCheck.addEventListener('click', function() {
    if(checkboxLayerE_LadeCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getE_LadeFeatures();
            E_LadeVector.setVisible(false);
            E_LadeVector.setVisible(true);
    }
    else {
            E_LadeVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerE_LadeCheck, checkboxLayerE_LadeCheck.className);
});

                                    /////////////////////////// Leben und Wohnen ///////////////////////////

var checkboxLayerStandesamtCheck = document.querySelector("button[id=LayerStandesamtCheck]");
checkboxLayerStandesamtCheck.addEventListener('click', function() {
    if(checkboxLayerStandesamtCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getStandesamtFeatures();
            StandesamtVector.setVisible(false);
            StandesamtVector.setVisible(true);
    }
    else {
            StandesamtVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerStandesamtCheck, checkboxLayerStandesamtCheck.className);
});

var checkboxLayerFriedhofCheck = document.querySelector("button[id=LayerFriedhofCheck]");
checkboxLayerFriedhofCheck.addEventListener('click', function() {
    if(checkboxLayerFriedhofCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getFriedhofFeatures();
            FriedhofVector.setVisible(false);
            FriedhofVector.setVisible(true);
    }
    else {
            FriedhofVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerFriedhofCheck, checkboxLayerFriedhofCheck.className);
});

var checkboxLayerIntegrationCheck = document.querySelector("button[id=LayerIntegrationCheck]");
checkboxLayerIntegrationCheck.addEventListener('click', function() {
    if(checkboxLayerIntegrationCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
        if (application.localeCompare('Integration_Behoerden')==0){
            getIntegration_BehoerdenFeatures();
        }
        else if (application.localeCompare('Integration_Beratung')==0){
            getIntegration_BeratungFeatures();
        }
        else if (application.localeCompare('Integration_Betreuung')==0){
            getIntegration_BetreuungFeatures();
        }
        else if (application.localeCompare('Integration_Bildungseinrichtungen')==0){
            getIntegration_BildungseinrichtungenFeatures();
        }
        else if (application.localeCompare('Integration_Freizeitangebote')==0){
            getIntegration_FreizeitangeboteFeatures();
        }
        else if (application.localeCompare('Integration_Wohnen')==0){
            getIntegration_WohnenFeatures();
        }
        else {
            getIntegrationFeatures();
        }
            IntegrationVector.setVisible(false);
            IntegrationVector.setVisible(true);
    }
    else {
            IntegrationVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerIntegrationCheck, checkboxLayerIntegrationCheck.className);
});

var checkboxLayerHundeCheck = document.querySelector("button[id=LayerHundeCheck]");
checkboxLayerHundeCheck.addEventListener('click', function() {
    if(checkboxLayerHundeCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getHundeFeatures();
            HundeVector.setVisible(false);
            HundeVector.setVisible(true);
            getHundeAlleFeatures();
            HundeAlleVector.setVisible(false);
            HundeAlleVector.setVisible(true);
            getHunde40cmFeatures();
            Hunde40cmVector.setVisible(false);
            Hunde40cmVector.setVisible(true);
            getHundeTuetenFeatures();
            HundeTuetenVector.setVisible(false);
            HundeTuetenVector.setVisible(true);
            getHundeStrandFeatures();
            HundeStrandVector.setVisible(false);
            HundeStrandVector.setVisible(true);
            getHundeZeitFeatures();
            HundeZeitVector.setVisible(false);
            HundeZeitVector.setVisible(true);
    }
    else {
            HundeVector.setVisible(false);
            HundeAlleVector.setVisible(false);
            Hunde40cmVector.setVisible(false);
            HundeTuetenVector.setVisible(false);
            HundeStrandVector.setVisible(false);
            HundeZeitVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerHundeCheck, checkboxLayerHundeCheck.className);
});


                                    /////////////////////////// Sicherheit und Ordnung ///////////////////////////

var checkboxLayerCityWCCheck = document.querySelector("button[id=LayerCityWCCheck]");
checkboxLayerCityWCCheck.addEventListener('click', function() {
    if(checkboxLayerCityWCCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getCityWCFeatures();
            CityWCVector.setVisible(false);
            CityWCVector.setVisible(true);
    }
    else {
            CityWCVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerCityWCCheck, checkboxLayerCityWCCheck.className);
});

var checkboxLayerReinigungCheck = document.querySelector("button[id=LayerReinigungCheck]");
checkboxLayerReinigungCheck.addEventListener('click', function() {
    if(checkboxLayerReinigungCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getReinigungFeatures();
            ReinigungVector.setVisible(false);
            ReinigungVector.setVisible(true);
    }
    else {
            ReinigungVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerReinigungCheck, checkboxLayerReinigungCheck.className);
});

var checkboxLayerWinterdienstCheck = document.querySelector("button[id=LayerWinterdienstCheck]");
checkboxLayerWinterdienstCheck.addEventListener('click', function() {
    if(checkboxLayerWinterdienstCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getWinterdienst1Features();
            Winterdienst1Vector.setVisible(false);
            Winterdienst1Vector.setVisible(true);
            getWinterdienst2Features();
            Winterdienst2Vector.setVisible(false);
            Winterdienst2Vector.setVisible(true);
    }
    else {
            Winterdienst2Vector.setVisible(false);
            Winterdienst1Vector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerWinterdienstCheck, checkboxLayerWinterdienstCheck.className);
});

var checkboxLayerParkplatzCheck = document.querySelector("button[id=LayerParkplatzCheck]");
checkboxLayerParkplatzCheck.addEventListener('click', function() {
    if(checkboxLayerParkplatzCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getParkplatzParkFeatures();
            ParkplatzParkVector.setVisible(false);
            ParkplatzParkVector.setVisible(true);
            getParkplatzBusFeatures();
            ParkplatzBusVector.setVisible(false);
            ParkplatzBusVector.setVisible(true);
            getParkplatzLKWFeatures();
            ParkplatzLKWVector.setVisible(false);
            ParkplatzLKWVector.setVisible(true);
    }
    else {
            ParkplatzParkVector.setVisible(false);
            ParkplatzBusVector.setVisible(false);
            ParkplatzLKWVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerParkplatzCheck, checkboxLayerParkplatzCheck.className);
});

var checkboxLayerP15Check = document.querySelector("button[id=LayerP15Check]");
checkboxLayerP15Check.addEventListener('click', function() {
    if(checkboxLayerP15Check.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getP15Features();
            P15Vector.setVisible(false);
            P15Vector.setVisible(true);
    }
    else {
            P15Vector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerP15Check, checkboxLayerP15Check.className);
});

            if ((application.localeCompare("Fruehjahrsputz")>=0)&&(application.localeCompare("Fruehjahrsputz_ZZZ")<0)){
var checkboxLayerFruehjahrsputzCheck = document.querySelector("button[id=LayerFruehjahrsputzCheck]");
checkboxLayerFruehjahrsputzCheck.addEventListener('click', function() {
    if(checkboxLayerFruehjahrsputzCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getFruehjahrsputzFeatures();
            FruehjahrsputzVector.setVisible(false);
            FruehjahrsputzVector.setVisible(true);
    }
    else {
            FruehjahrsputzVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerFruehjahrsputzCheck, checkboxLayerFruehjahrsputzCheck.className);
});
            }

                                    /////////////////////////// Bildung und Sport ///////////////////////////

var checkboxLayerSchulenCheck = document.querySelector("button[id=LayerSchulenCheck]");
checkboxLayerSchulenCheck.addEventListener('click', function () {
    if (checkboxLayerSchulenCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
        getSchulenFeatures();
        SchulenVector.setVisible(false);
        SchulenVector.setVisible(true);
    }
    else {
        SchulenVector.setVisible(false);
    }

    toggleColoring(checkboxLayerSchulenCheck, checkboxLayerSchulenCheck.className);
});

var checkboxLayerKitasCheck = document.querySelector("button[id=LayerKitasCheck]");
checkboxLayerKitasCheck.addEventListener('click', function () {
    if (checkboxLayerKitasCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
        getKitasFeatures();
        KitasVector.setVisible(false);
        KitasVector.setVisible(true);
    }
    else {
        KitasVector.setVisible(false);
    }

    toggleColoring(checkboxLayerKitasCheck, checkboxLayerKitasCheck.className);
});

var checkboxLayerSportplaetzeCheck = document.querySelector("button[id=LayerSportplaetzeCheck]");
checkboxLayerSportplaetzeCheck.addEventListener('click', function() {
    if(checkboxLayerSportplaetzeCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSportplaetzeFeatures();
            SportplaetzeVector.setVisible(false);
            SportplaetzeVector.setVisible(true);
    }
    else {
            SportplaetzeVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerSportplaetzeCheck, checkboxLayerSportplaetzeCheck.className);
});

var checkboxLayerSpielplaetzeCheck = document.querySelector("button[id=LayerSpielplaetzeCheck]");
checkboxLayerSpielplaetzeCheck.addEventListener('click', function() {
    if(checkboxLayerSpielplaetzeCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            getSpielplaetzeFeatures();
            SpielplaetzeVector.setVisible(false);
            SpielplaetzeVector.setVisible(true);
    }
    else {
            SpielplaetzeVector.setVisible(false);
    }
    
    toggleColoring(checkboxLayerSpielplaetzeCheck, checkboxLayerSpielplaetzeCheck.className);
});

                                    /////////////////////////// Umwelt ///////////////////////////
/*
var checkboxLayerMVSchutzCheck = document.querySelector("button[id=LayerMVSchutzCheck]");
checkboxLayerMVSchutzCheck.addEventListener('click', function() {
    if(checkboxLayerMVSchutzCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerMVSchutz.setVisible(true);
    }
    else {
            wmsLayerMVSchutz.setVisible(false);
    }
    
    toggleColoring(checkboxLayerMVSchutzCheck, checkboxLayerMVSchutzCheck.className);
});
*/
                                    /////////////////////////// Weitere Karten ///////////////////////////

var checkboxLayerKommunFlCheck = document.querySelector("button[id=LayerKommunFlCheck]");
checkboxLayerKommunFlCheck.addEventListener('click', function() {
    if(checkboxLayerKommunFlCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerKommunFl.setVisible(true);
    }
    else {
            wmsLayerKommunFl.setVisible(false);
    }
    
    toggleColoring(checkboxLayerKommunFlCheck, checkboxLayerKommunFlCheck.className);
});

var checkboxLayerStadtkarteCheck = document.querySelector("button[id=LayerStadtkarteCheck]");
checkboxLayerStadtkarteCheck.addEventListener('click', function() {
    if(checkboxLayerStadtkarteCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerStadtkarte.setVisible(true);
    }
    else {
            wmsLayerStadtkarte.setVisible(false);
    }
    
    toggleColoring(checkboxLayerStadtkarteCheck, checkboxLayerStadtkarteCheck.className);
});

var checkboxLayerUebersichtskarteCheck = document.querySelector("button[id=LayerUebersichtskarteCheck]");
checkboxLayerUebersichtskarteCheck.addEventListener('click', function() {
    if(checkboxLayerUebersichtskarteCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerUebersichtskarte.setVisible(true);
    }
    else {
            wmsLayerUebersichtskarte.setVisible(false);
    }
    
    toggleColoring(checkboxLayerUebersichtskarteCheck, checkboxLayerUebersichtskarteCheck.className);
});

var checkboxLayerDOPCheck = document.querySelector("button[id=LayerDOPCheck]");
checkboxLayerDOPCheck.addEventListener('click', function() {
    if(checkboxLayerDOPCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            wmsLayerORKA.setVisible(false);
            wmsLayerDOP.setVisible(true);
            toggleColoring(document.getElementById("LayerORKACheck"), "btn btn-primary btn-rounded btn-block my-2");
    }
    else {
            wmsLayerDOP.setVisible(false);
    }
    
    toggleColoring(checkboxLayerDOPCheck, checkboxLayerDOPCheck.className);
});

var checkboxLayerORKACheck = document.querySelector("button[id=LayerORKACheck]");
checkboxLayerORKACheck.addEventListener('click', function () {
    if (checkboxLayerORKACheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
        wmsLayerORKA.setVisible(true);
        wmsLayerDOP.setVisible(false);
        toggleColoring(document.getElementById("LayerDOPCheck"), "btn btn-primary btn-rounded btn-block my-2");
    }
    else {
        wmsLayerORKA.setVisible(false);
    }

    toggleColoring(checkboxLayerORKACheck, checkboxLayerORKACheck.className);
});
var checkboxLayerOSMCheck = document.querySelector("button[id=LayerOSMCheck]");
checkboxLayerOSMCheck.addEventListener('click', function () {
    if (checkboxLayerOSMCheck.className.localeCompare("btn btn-info btn-rounded btn-block my-2") == 0) {
        wmsLayerOSM.setVisible(true);
        OSMWmsLayer.setVisible(true);
        //wmsLayerDOP.setVisible(false);
        //toggleColoring(document.getElementById("LayerDOPCheck"), "btn btn-primary btn-rounded btn-block my-2");
    }
    else {
        wmsLayerOSM.setVisible(false);
        OSMWmsLayer.setVisible(false);
    }

    toggleColoring(checkboxLayerOSMCheck, checkboxLayerOSMCheck.className);
});

                                    ///// --- Ende Toggle Event Listener --- /////

function toggleColoring(element, Klasse){
    if (Klasse.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
            element.className="btn btn-primary btn-rounded btn-block my-2";
    }
    else {
            element.className="btn btn-info btn-rounded btn-block my-2";
    }
    element.blur();         
}

function toggleTrack(element){
        if(element.className.localeCompare("btn btn-info btn-rounded btn-block my-2")==0){
               geolocation.setTracking(true);
               positionLayer.setVisible(true);
        }
        else {
               geolocation.setTracking(false);
               positionLayer.setVisible(false);
        }
}

                                ///// ---- Beginn Get Objects des Layers ---- /////

                                    /////////////////////////// Wirtschaft und Entwicklung ///////////////////////////

function getWahllokaleBezirkFeatures(){
    WahllokaleBezirkSource.clear();
    $.getJSON('../../lib7/sources/Wahllokale_2022/shape/Wahlbezirke.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    WahllokaleBezirkSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            WahllokaleBezirkVector.setStyle(getStyleWahllokaleBezirkWithLabel);
    });
}
function getStyleWahllokaleBezirkWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorStroke = 'rgba(0, 0, 0, 0.4)';
    var lineDashArray = [5,0];
    var colorFill = 'rgba(0, 0, 0, 0)';
    var fontLayer = '70px arial';
    var label = 'Titel';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var colorText = 'rgba(255, 0, 0, 0)';
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 3;
    var radiusPoint = 10;

    var Klasse = feature.get('ID');
    if (Klasse=='1'){
        var colorFill = 'rgba(204, 255, 153, 0.6)';             
    }     
    else if (Klasse=='2'){
        var colorFill = 'rgba(102, 153, 204, 0.6)';
    }     
    else if (Klasse=='3'){
        var colorFill = 'rgba(153, 153, 0, 0.6)';
    }     
    else if (Klasse=='4'){                  
        var colorFill = 'rgba(255, 153, 51, 0.6)';      
    }     
    else if (Klasse=='5'){
        var colorFill = 'rgba(255, 255, 153, 0.6)';    
    }     
    else if (Klasse=='6'){
        var colorFill = 'rgba(153, 153, 153, 0.6)';      
    }     
    else if (Klasse=='7'){
        var colorFill = 'rgba(102, 153, 102, 0.6)';       
    }     
    else if (Klasse=='8'){
        var colorFill = 'rgba(153, 204, 51, 0.6)';           
    }     
    else if (Klasse=='9'){
        var colorFill = 'rgba(153, 102, 51, 0.6)';     
    }     
    else if (Klasse=='10'){
        var colorFill = 'rgba(153, 0, 51, 0.6)';     
    }     
    else if (Klasse=='11'){
        var colorFill = 'rgba(255, 0, 51, 0.6)';     
    }     
    else if (Klasse=='12'){
        var colorFill = 'rgba(255, 204, 51, 0.6)';     
    }     
    else if (Klasse=='13'){
        var colorFill = 'rgba(255, 102, 51, 0.6)';     
    }     
    else if (Klasse=='14'){
        var colorFill = 'rgba(204, 153, 153, 0.6)';     
    }     
    else if (Klasse=='15'){
        var colorFill = 'rgba(153, 102, 255, 0.6)';     
    }     
    else if (Klasse=='16'){
        var colorFill = 'rgba(204, 204, 255, 0.6)';     
    }     
    else if (Klasse=='17'){
        var colorFill = 'rgba(204, 204, 204, 0.6)';     
    }     
    else if (Klasse=='18'){
        var colorFill = 'rgba(204, 102, 204, 0.6)';     
    }     
   
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}
function getWahllokaleStandortFeatures(){
    WahllokaleStandortSource.clear();
    $.getJSON('../../lib7/sources/Wahllokale_2022/shape/Standort.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                WahllokaleStandortSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            WahllokaleStandortVector.setStyle(getStyleWahllokaleStandortIcon);

}
function getStyleWahllokaleStandortIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_schwarz.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });     
}
function getWahllokaleNummerFeatures(){
    WahllokaleNummerSource.clear();
    $.getJSON('../../lib7/sources/Wahllokale_2022/shape/Wahllokale_Nummer.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                WahllokaleNummerSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            WahllokaleNummerVector.setStyle(getStyleWahllokaleNummerWithLabel);
    });
}
function getStyleWahllokaleNummerWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorStroke = 'rgba(0, 0, 0, 0)';
    var lineDashArray = [5, 0];
    var colorFill = 'rgba(204, 255, 153, 0)';             
    var fontLayer = '30px arial';
    var label = 'Text1';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var colorText = 'rgba(0, 0, 0, 1)';
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 3;
    var radiusPoint = 10;
   
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getBPlaene_allFeatures(){
    BPlaeneSource.clear();
    $.getJSON('../../lib7/sources/B-Plaene/shape/BPL_118_Umring.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Klasse', 'BPlaeneUmring');
                BPlaeneSource.addFeature(element);
        }
            BPlaeneVector.setStyle(getStyleBPlaeneWithLabel);
    });
    VBPlaeneSource.clear();
    $.getJSON('../../lib7/sources/B-Plaene/shape/V-B-Plaene2.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            if (element.get('Kompens') == 'true') {
                element.set('Klasse', 'KompensVBPlaene');
            }
            else {
                element.set('Klasse', 'VBPlaene');
            }
                VBPlaeneSource.addFeature(element);
        }
            VBPlaeneVector.setStyle(getStyleBPlaeneWithLabel);
    });
    BPlaeneUmringSource.clear();
    
    $.getJSON('../../lib7/sources/B-Plaene/shape/B-Plaene_A.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                if (element.get('Kompens')=='true'){
                    element.set('Klasse', 'KompensAufstellung');
                }
                else {
                    element.set('Klasse', 'BPlaeneAufstellung');
                }
                BPlaeneUmringSource.addFeature(element);
        }
            BPlaeneUmringVector.setStyle(getStyleBPlaeneWithLabel);
    });
    
    $.getJSON('../../lib7/sources/B-Plaene/shape/B-Plaene.geojson', function (data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
        //        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++) {
            var element = ObjectArray.pop();
            if (element.get('Kompens') == 'true') {
                element.set('Klasse', 'Kompens');
            }
            else {
                element.set('Klasse', 'BPlaene');
            }
            BPlaeneUmringSource.addFeature(element);
        }
        BPlaeneUmringVector.setStyle(getStyleBPlaeneWithLabel);
    });
}
function getBPlaeneFeatures(){
    BPlaeneSource.clear();
    $.getJSON('../../lib7/sources/B-Plaene/shape/B-Plaene.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                if (element.get('Kompens')=='true'){
                    element.set('Klasse', 'Kompens');
                }
                else {
                    element.set('Klasse', 'BPlaene');
                }
                BPlaeneSource.addFeature(element);
        }
            BPlaeneVector.setStyle(getStyleBPlaeneWithLabel);
    });
    $.getJSON('../../lib7/sources/B-Plaene/shape/BPL_118_Umring.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Klasse', 'BPlaeneUmring');
                BPlaeneSource.addFeature(element);
        }
                
            BPlaeneVector.setStyle(getStyleBPlaeneWithLabel);
    });

}

function getVBPlaeneFeatures(){
    BPlaeneSource.clear();
    $.getJSON('../../lib7/sources/B-Plaene/shape/BPL_118_Umring.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Klasse', 'BPlaeneUmring');
                BPlaeneSource.addFeature(element);
        }
            BPlaeneVector.setStyle(getStyleBPlaeneWithLabel);
    });
    $.getJSON('../../lib7/sources/B-Plaene/shape/V-B-Plaene2.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Klasse', 'VBPlaene');
                BPlaeneSource.addFeature(element);
        }
            BPlaeneVector.setStyle(getStyleBPlaeneWithLabel);
    });
}
function getBPlaeneTifFeatures(application){
    BPlaeneSource.clear();
    var applicationArray = application.split('_');
    var arraySize = applicationArray.length;
    var URL = '../../lib7/sources/B-Plaene/shape/B-Plaene_Tif_Bereich.geojson';
    var URLTif = 'https://wms01.neubrandenburg.de/cgi-bin/mapserv?map=/data/umn/extern/B-Plaene/B_raster.map&';
/*
    var URL = '../../lib7/sources/B-Plaene/raster/BPL_'+applicationArray[2]+'/BPL';
    var URLTif = 'https://wms01.neubrandenburg.de/cgi-bin/mapserv?map=/data/umn/extern/B-Plaene/BPL';
    var LayerTif = 'BPL';
    for (var inc=2; inc<arraySize; inc++){
        URL+='_'+applicationArray[inc];                
        LayerTif+='_'+applicationArray[inc];                 
        URLTif+='_'+applicationArray[inc];                 
    }
    URL+='_Bereich.geojson'; 
    URLTif+='.map&';
*/
    $.getJSON(URL, function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    element.set('Klasse', 'Tif');
                BPlaeneTifSource.addFeature(element);
        }
            BPlaeneTifVector.setStyle(getStyleBPlaeneWithLabel);
    });
    
//    wmsSourceBPlaeneTif.setUrl(URLTif);
    var wmsSourceBPlaeneTifNew = new TileWMS({
      url: URLTif,
      params: {
        'LAYERS': ['BPL_10_1-Aenderung_Satzung', 'BPL_16-1_1-Aenderung_Satzung', 'BPL_122_Satzung', 'Informationen'],
        'VERSION': '1.3.0',
        'FORMAT': 'image/png',
        'TILED': true
      },
      serverType: 'mapserver'
    });

    wmsLayerBPlaeneTif.setSource(wmsSourceBPlaeneTifNew);


}
function getStyleBPlaeneWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(0, 0, 255, 0.6)';
    var colorStroke = 'rgba(255, 255, 255, 0.6)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(255, 255, 255, 1)';
    var fontLayer = '27px arial';
    var label = 'NUMMER';
    var strokeText = 'rgba(255, 255, 255, 0)';
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 2;
    var radiusPoint = 10;

    var Klasse=feature.get('Klasse');
    if (0){
    }
    else if (Klasse=='BPlaene'){
    }
    else if (Klasse=='Kompens'){
        var colorFill = 'rgba(51, 153, 0, 0.6)';
    }
    else if (Klasse=='BPlaeneUmring'){
    }
    else if (Klasse=='VBPlaene'){
        var colorFill = 'rgba(125, 0, 200, 0.6)';
    }
    else if (Klasse == 'KompensVBPlaene') {
        var colorFill = 'rgba(51, 153, 0, 0.6)';
    }
    else if (Klasse == 'BPlaeneAufstellung') {
        var colorFill = 'rgba(0, 0, 0, 0)';
        var colorStroke = 'rgba(0, 0, 0, 1)';
        var lineDashArray = [5, 5];
        var widthBorder = 4;
        var colorText = 'rgba(0, 0, 0, 1)';
    }
    else if (Klasse == 'KompensAufstellung') {
        var colorFill = 'rgba(0, 0, 0, 0)';
        var colorStroke = 'rgba(0, 153, 0, 1)';
        var lineDashArray = [5, 5];
        var widthBorder = 4;
        var colorText = 'rgba(0, 153, 0, 1)';
    }
    else if (Klasse=='Tif'){
        var colorFill = 'rgba(0, 0, 0, 1)';
        var colorStroke = 'rgba(0, 0, 0, 0)';
        var colorText = 'rgba(0, 0, 0, 0)';
    }

    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getGewerbeFeatures(){
    GewerbeSource.clear();
    $.getJSON('../../lib7/sources/Gewerbe/shape/gewerbe_umringe.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                element.set('Layer', 'GewerbeUmringe');
                if (element.get('Titel')!='Gewerbegebiet Weitin Stadtblick'){
                        GewerbeSource.addFeature(element);
                }
        }

            GewerbeVector.setStyle(getStyleGewerbeWithLabel);
    });
    $.getJSON('../../lib7/sources/Gewerbe/shape/fg.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Layer', 'GewerbeUmringeOptional');
                GewerbeSource.addFeature(element);
        }

            GewerbeVector.setStyle(getStyleGewerbeWithLabel);
    });
    $.getJSON('../../lib7/sources/Gewerbe/shape/gewerbe_frei.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Layer', 'GewerbeFrei');
            if (element.get('Titel')!='Weitin Stadtblick'){
                GewerbeSource.addFeature(element);
            }
        }

            GewerbeVector.setStyle(getStyleGewerbeWithLabel);
    });
    $.getJSON('../../lib7/sources/Gewerbe/shape/gewerbe_reserviert_2.geojson', function (data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++) {
            var element = ObjectArray.pop();
            element.set('Layer', 'GewerbeReserviert2');
            if (element.get('Titel') != 'Weitin Stadtblick') {
                GewerbeSource.addFeature(element);
            }
        }

        GewerbeVector.setStyle(getStyleGewerbeWithLabel);
    });
}
function getStyleGewerbeWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(0, 205, 0, 1)';
    var colorStroke = 'rgba(255, 255, 255, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Titel';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = true;
    var widthBorder = 1;
    var radiusPoint = 10;

    var Layer=feature.get('Layer');
    if (Layer=='GewerbeFrei'){
        var label = 'Nummer';

        var Klasse = feature.get('Reserviert');
        if (Klasse=='true'){
            var colorFill = 'rgba(255, 51, 51, 1)';
        }
        else if (Klasse == 'hidden') {
            var colorFill = 'rgba(0, 0, 0, 0)';
            var colorStroke = 'rgba(255, 255, 255, 0)';
            var label = '';
        }
        else if (Klasse == 'verkauft') {
            var colorFill = 'rgba(0, 0, 0, 0)';
            var colorStroke = 'rgba(255, 255, 255, 0)';
            var label = '';
        }
       else {
            var colorFill = 'rgba(218, 165, 32, 1)';
        }
    }
    else if (Layer=='GewerbeUmringe'){
        var colorFill = 'rgba(0, 205, 0, 0.7)';
        var overflowLabel = false;
    }
    else if (Layer=='GewerbeUmringeOptional'){
        var colorFill = 'rgba(0, 205, 205, 0.7)';
    }
    else if (Layer == 'GewerbeReserviert2') {
        var label = 'Nummer';
        var colorFill = 'rgba(8, 17, 253, 1)';
    }

    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}    

function getStatistikAllFeatures(){
    StatistikAllSource.clear();
    $.getJSON('../../lib7/sources/Statistik/shape/all.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    StatistikAllSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            StatistikAllVector.setStyle(getStyleStatistikAllWithLabel);
    });
}
function getStyleStatistikAllWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(255, 255, 0, 0)';
    var colorStroke = 'rgba(0, 0, 0, 0.4)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Layer';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 3;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}
function getStatistikStadtteileFeatures(){
    StatistikStadtteileSource.clear();
    $.getJSON('../../lib7/sources/Statistik/shape/stadtteile.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    StatistikStadtteileSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            StatistikStadtteileVector.setStyle(getStyleStatistikStadtteileWithLabel);
    });
}
function getStyleStatistikStadtteileWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorStroke = 'rgba(255, 255, 255, 0.4)';
    var lineDashArray = [5, 0];
    var fontLayer = '70px arial';
    var label = 'Titel';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 3;
    var radiusPoint = 10;

    var StadtteileNummer = feature.get('Nummer');
    if (StadtteileNummer=='010'){
        var colorFill = 'rgba(251, 250, 163, 0.4)';             
        var colorText = 'rgba(255, 0, 0, 0)';
    }     
    else if (StadtteileNummer=='020'){
        var colorFill = 'rgba(207, 208, 255, 0.4)';
        var colorText = 'rgba(255, 0, 0, 1)';
    }     
    else if (StadtteileNummer=='030'){
        var colorFill = 'rgba(255, 153, 153, 0.4)';
        var colorText = 'rgba(255, 0, 0, 0)';
    }     
    else if (StadtteileNummer=='040'){                  
        var colorFill = 'rgba(204, 102, 51, 0.4)';      
        var colorText = 'rgba(255, 0, 0, 1)';
    }     
    else if (StadtteileNummer=='050'){
        var colorFill = 'rgba(212, 255, 207, 0.4)';    
        var colorText = 'rgba(255, 0, 0, 1)';
    }     
    else if (StadtteileNummer=='060'){
        var colorFill = 'rgba(51, 255, 255, 0.4)';      
        var colorText = 'rgba(255, 0, 0, 1)';
    }     
    else if (StadtteileNummer=='080'){
        var colorFill = 'rgba(209, 254, 162, 0.4)';       
        var colorText = 'rgba(255, 0, 0, 1)';
    }     
    else if (StadtteileNummer=='090'){
        var colorFill = 'rgba(165, 152, 252, 0.4)';           
        var colorText = 'rgba(255, 0, 0, 0)';
    }     
    else if (StadtteileNummer=='100'){
        var colorFill = 'rgba(249, 162, 206, 0.4)';     
        var colorText = 'rgba(255, 0, 0, 1)';
    }     
    else if (StadtteileNummer=='110'){
        var colorFill = 'rgba(157, 209, 255, 0.4)';       
        var colorText = 'rgba(255, 0, 0, 1)';
    }     
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getEinzelhandel_AFeatures(){
   EinzelhandelSource.clear();
    $.getJSON('../../lib7/sources/Einzelhandel/shape/einzelhandel_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Hierarchie');
                if (Klasse=='A-Zentrum'){
                    EinzelhandelSource.addFeature(element);
                	
                }
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
//            console.log(JSON.stringify(element));
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            EinzelhandelVector.setStyle(getStyleEinzelhandelWithLabel);
    });
}
function getEinzelhandel_BFeatures(){
   EinzelhandelSource.clear();
    $.getJSON('../../lib7/sources/Einzelhandel/shape/einzelhandel_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Hierarchie');
                if (Klasse=='B-Zentrum'){
                    EinzelhandelSource.addFeature(element);
                	
                }
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
//            console.log(JSON.stringify(element));
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            EinzelhandelVector.setStyle(getStyleEinzelhandelWithLabel);
    });
}
function getEinzelhandel_CFeatures(){
   EinzelhandelSource.clear();
    $.getJSON('../../lib7/sources/Einzelhandel/shape/einzelhandel_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Hierarchie');
                if (Klasse=='C-Zentrum'){
                    EinzelhandelSource.addFeature(element);
                	
                }
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
//            console.log(JSON.stringify(element));
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            EinzelhandelVector.setStyle(getStyleEinzelhandelWithLabel);
    });
}
function getEinzelhandel_DFeatures(){
   EinzelhandelSource.clear();
    $.getJSON('../../lib7/sources/Einzelhandel/shape/einzelhandel_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Hierarchie');
                if (Klasse=='D-Zentrum'){
                    EinzelhandelSource.addFeature(element);
                	
                }
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
//            console.log(JSON.stringify(element));
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            EinzelhandelVector.setStyle(getStyleEinzelhandelWithLabel);
    });
}
function getEinzelhandel_EFeatures(){
   EinzelhandelSource.clear();
    $.getJSON('../../lib7/sources/Einzelhandel/shape/einzelhandel_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Hierarchie');
                if (Klasse=='Dezentraler Fachmarktstandort'){
                    EinzelhandelSource.addFeature(element);
                	
                }
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
//            console.log(JSON.stringify(element));
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            EinzelhandelVector.setStyle(getStyleEinzelhandelWithLabel);
    });
}
function getEinzelhandel_FFeatures(){
   EinzelhandelSource.clear();
    $.getJSON('../../lib7/sources/Einzelhandel/shape/einzelhandel_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Hierarchie');
                if (Klasse=='Versorgungsstandorte Lebensmittel'){
                    EinzelhandelSource.addFeature(element);
                	
                }
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
//            console.log(JSON.stringify(element));
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);

            EinzelhandelVector.setStyle(getStyleEinzelhandelWithLabel);
    });
}
function getEinzelhandelFeatures(){
   EinzelhandelSource.clear();
    $.getJSON('../../lib7/sources/Einzelhandel/shape/einzelhandel_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    EinzelhandelSource.addFeature(element);
        }

            EinzelhandelVector.setStyle(getStyleEinzelhandelWithLabel);
    });
}
function getStyleEinzelhandelWithLabel(feature){
    //Werte f�r meisten Klassen
    var fontLayer = (1/view.getResolution()*130)+'px arial';
    var radiusPoint = 1/view.getResolution()*105;
    var colorStroke = 'rgba(0, 0, 0, 0.6)';
    var lineDashArray = [5, 0];
    var label = 'Nummer';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 3;

    var Klasse = feature.get('Hierarchie');
    if (Klasse=='Versorgungsstandorte Lebensmittel'){
        var colorFill = 'rgba(0, 112, 192, 0.6)';             
        var colorText = 'rgba(255, 255, 255, 0.6)';
    }     
    else if (Klasse=='Dezentraler Fachmarktstandort'){
        var colorFill = 'rgba(112, 48, 160, 0.6)';
        var colorText = 'rgba(255, 255, 255, 0.6)';
    }     
    else if (Klasse=='D-Zentrum'){
        var colorFill = 'rgba(84, 130, 53, 0.6)';
        var colorText = 'rgba(0, 0, 0, 0.6)';
    }     
    else if (Klasse=='C-Zentrum'){                  
        var colorFill = 'rgba(255, 192, 0, 0.6)';      
        var colorText = 'rgba(0, 0, 0, 0.6)';
    }     
    else if (Klasse=='B-Zentrum'){
        var colorFill = 'rgba(244, 177, 131, 0.6)';    
        var colorText = 'rgba(0, 0, 0, 0.6)';
        var radiusPoint = 1/view.getResolution()*210;
    }     
    else if (Klasse=='A-Zentrum'){
        var colorFill = 'rgba(192, 0, 0, 0.6)';      
        var colorText = 'rgba(255, 255, 255, 0.6)';
        var radiusPoint = 1/view.getResolution()*420;
        var fontLayer = (1/view.getResolution()*260)+'px arial';
    }     
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getErhaltungssatzungenFeatures(){
    ErhaltungssatzungenSource.clear();
    $.getJSON('../../lib7/sources/Erhaltungssatzungen/shape/erhaltungs_extern.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                ErhaltungssatzungenSource.addFeature(element);
        }
    });

            ErhaltungssatzungenVector.setStyle(getStyleErhaltungssatzungenWithLabel);
}
function getStyleErhaltungssatzungenWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(213, 172, 82, 0.6)';
    var colorStroke = 'rgba(255, 255, 255, 0.6)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Bereich';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = true;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getBauaufsichtsbezirkeFeatures(){
    $.getJSON('../../lib7/sources/Bauaufsichtsbezirke/shape/Zustaendigkeiten_Bauordnung.geojson', function(data) {
        var GeoJSONFlash = new GeoJSON;
        var ObjectArray = GeoJSONFlash.readFeatures(data);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Layer', 'BauaufsichtsbezirkeFrei');
            if (element.get('Titel')!='Weitin Stadtblick'){
                BauaufsichtsbezirkeSource.addFeature(element);
            }
        }

            BauaufsichtsbezirkeVector.setStyle(getStyleBauaufsichtsbezirkeWithLabel);
    });
}
function getStyleBauaufsichtsbezirkeWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(0, 0, 255, 1)';
    var colorStroke = 'rgba(0, 0, 0, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(255, 255, 255, 0)';
    var fontLayer = '27px arial';
    var label = 'LAYER';
    var strokeText = 'rgba(255, 255, 255, 0)';
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 2;
    var radiusPoint = 10;

    var Klasse=feature.get('LAYER');
    if (Klasse == 'Frau Gattig') {
        var colorFill = 'rgba(255, 190, 190, 1)';
    }
    else if (Klasse == 'Frau Baldauf') {
        var colorFill = 'rgba(255, 190, 190, 1)';
    }
    else if (Klasse=='Frau Nietiedt'){
        var colorFill = 'rgba(255, 180, 100, 1)';
    }
    else if (Klasse=='Frau Matthaei'){
        var colorFill = 'rgba(255, 255, 140, 1)';
    }
    else if (Klasse =='Frau Nehring'){
        var colorFill = 'rgba(200, 235, 170, 1)';
    }
    else if (Klasse =='Herr Krueger'){
        var colorFill = 'rgba(235, 220, 206, 1)';
    }
            
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getSolarpotentialFeatures(){
   SolarpotentialSource.clear();
    $.getJSON('../../lib7/sources/Solarpotential_NB/shape/gesamt.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    SolarpotentialSource.addFeature(element);
        }

            SolarpotentialVector.setStyle(getStyleSolarpotentialWithLabel);
    });
}
function getStyleSolarpotentialWithLabel(feature){
    //Werte f�r meisten Klassen
    var fontLayer = (1/view.getResolution()*130)+'px arial';
    var radiusPoint = 1/view.getResolution()*105;
    var colorStroke = 'rgba(0, 0, 0, 1)';
    var lineDashArray = [5, 0];
    var label = '';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 3;
        var colorFill = 'rgba(255, 0, 0, 1)';      
        var colorText = 'rgba(0, 0, 0, 0)';

    var Klasse = feature.get('Eignung_PV');
    if (Klasse=='sehr gut geeignet'){
        colorFill = 'rgba(27, 192, 55, 1)';           
    }     
    else if (Klasse=='gut geeignet'){
        colorFill = 'rgba(255, 255, 0, 1)'; 
    }     
    else if (Klasse=='geeignet'){
        colorFill = 'rgba(255, 148, 0, 1)'; 
    }     
    else if (Klasse=='nicht geeignet'){                  
        colorFill = 'rgba(255, 0, 0, 1)';      
    }     
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getWohnungsbauFeatures() {
    WohnungsbauSource.clear();
    $.getJSON('../../lib7/sources/Wohnungsbau/shape/baustandorte.geojson', function (data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
        //        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++) {
            var element = ObjectArray.pop();
            WohnungsbauSource.addFeature(element);
        }

        WohnungsbauVector.setStyle(getStyleWohnungsbauWithLabel);
    });
}
function getStyleWohnungsbauWithLabel(feature) {
    /*
    var fontLayer = (1 / view.getResolution() * 130) + 'px arial';
    var radiusPoint = 1 / view.getResolution() * 105;
    var colorStroke = 'rgba(255, 255, 255, 1)';
    var lineDashArray = [5, 0];
    var label = 'Nummer';
    var strokeText = 'rgba(0, 0, 0, 1)';
    var widthLabelBorder = 0;
    var overflowLabel = false;
    var widthBorder = 1;
    var colorFlash = feature.get('Color').split(' ');
    var colorFill = 'rgba(' + colorFlash[0] + ',' + colorFlash[1] + ',' + colorFlash[2] + ', 1)';
    var colorText = 'rgba(0, 0, 0, 1)';
    */

//    var Klasse = feature.get('Color');
//    if (Klasse == 'sehr gut geeignet') {
//        colorFill = 'rgba(0, 255, 0, 1)';
//    }
    //Werte f�r meisten Klassen
    var colorFlash = feature.get('Color').split(' ');
    var colorFill = 'rgba(' + colorFlash[0] + ',' + colorFlash[1] + ',' + colorFlash[2] + ', 1)';
    var colorStroke = 'rgba(255, 255, 255, 1)';
    var lineDashArray = [0, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '14px arial';
    var label = 'Nummer';
    var strokeText = 'rgba(255, 255, 255, 0)';
    var widthLabelBorder = 0;
    var overflowLabel = true;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

                                    /////////////////////////// Kultur und Tourismus ///////////////////////////

function getBaudenkmaleAll2018Features(){
    BaudenkmaleAll2018Source.clear();
    $.getJSON('../../lib7/sources/Baudenkmale/shape/Baudenkmal_all2.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                BaudenkmaleAll2018Source.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            BaudenkmaleAll2018Vector.setStyle(getStyleBaudenkmaleIcon);
}
function getBaudenkmaleAllNeuFeatures(){
    BaudenkmaleAllNeuSource.clear();
    $.getJSON('../../lib7/sources/Baudenkmale/shape/Baudenkmal_all_neu.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                BaudenkmaleAllNeuSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            BaudenkmaleAllNeuVector.setStyle(getStyleBaudenkmaleIcon);
}
function getBaudenkmaleFeatures(){
    BaudenkmaleSource.clear();
    $.getJSON('../../lib7/sources/Baudenkmale/shape/Bau.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                BaudenkmaleSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            BaudenkmaleVector.setStyle(getStyleBaudenkmaleIcon);
}
function getBaudenkmaleFlaechenFeatures() {
    BaudenkmaleFlaechenSource.clear();
    $.getJSON('../../lib7/sources/Baudenkmale/shape/Baudenkmal_all_flaechen.geojson', function (data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
        //        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++) {
            var element = ObjectArray.pop();
            BaudenkmaleFlaechenSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

    BaudenkmaleFlaechenVector.setStyle(getStyleBaudenkmaleFlaechen);
}
function getStyleBaudenkmaleIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Baudenkmale/denkmal.png',
            //size: [50,50] //cuts off picture
            scale: 0.2
        }),
    });     
}
function getStyleBaudenkmaleFlaechen(feature) {
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(182, 72, 73, 0.6)';
    var colorStroke = 'rgba(255, 255, 255, 0.6)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = '';
    var strokeText = 'rgba(0, 0, 0, 0)';
    var widthLabelBorder = 0;
    var overflowLabel = true;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getDenkmalbereicheFeatures(){
    DenkmalbereicheSource.clear();
    $.getJSON('../../lib7/sources/Denkmalbereiche/shape/denkmalbereiche.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                DenkmalbereicheSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            DenkmalbereicheVector.setStyle(getStyleDenkmalbereicheWithLabel);
}
function getStyleDenkmalbereicheWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(204, 0, 204, 0.6)';
    var colorStroke = 'rgba(255, 255, 255, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Bereich';
    var strokeText = 'rgba(0, 0, 0, 0)';
    var widthLabelBorder = 0; 
    var overflowLabel = true;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}
function getKunstAllFeatures(){
    KunstSource.clear();
    $.getJSON('../../lib7/sources/Kunst/shape/kunst.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                KunstAllSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            KunstAllVector.setStyle(getStyleKunstIcon);
}
function getKunstFeatures(){
    KunstSource.clear();
    $.getJSON('../../lib7/sources/Kunst/shape/kunst_city.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                KunstSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            KunstVector.setStyle(getStyleKunstIcon);
}
function getStyleKunstIcon(feature){
    var Klasse = feature.get('Audio');
    if (Klasse == null) {
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Kunst/symbol_kunst.png',
                //size: [50,50] //cuts off picture
                scale: 2
            }),
        });

    }
    else {
        return new Style({
            image: new Icon({
                src: 'http://geoserver.neubrandenburg.de/Bilder/Kunst/symbol_kunst_audio8.png',
                //size: [50,50] //cuts off picture
                scale: 0.5
            }),
        });     
    }
}

function getHistoFeatures(){
    HistoSource.clear();
    $.getJSON('../../lib7/sources/Historische_Plaetze/shape/Histo.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                HistoSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            HistoVector.setStyle(getStyleHistoWithLabel);
}
function getStyleHistoWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(233, 115, 0, 1)';
    var colorStroke = 'rgba(255, 255, 255, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Titel';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = true;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getTollenseseeFeatures(){
    TollenseseeSource.clear();
    $.getJSON('../../lib7/sources/Tollensesee/shape/parkp_see.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Mobile_Klasse', 'Parkplatz');
                TollenseseeSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });
    $.getJSON('../../lib7/sources/Tollensesee/shape/praehis.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Mobile_Klasse', 'Praehis');
                TollenseseeSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });
    $.getJSON('../../lib7/sources/Tollensesee/shape/Restaurant.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Mobile_Klasse', 'Restaurant');
                TollenseseeSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            TollenseseeVector.setStyle(getStyleTollenseseeIcon);
}
function getStyleTollenseseeIcon(feature){
  var Mobile_Klasse=feature.get('Mobile_Klasse');
  if (Mobile_Klasse=='Parkplatz'){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Landschaftsgarten/p_bild.png',
            //size: [50,50] //cuts off picture
            scale: 0.75
        }),
    });     
  }
  else if (Mobile_Klasse=='Praehis'){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Landschaftsgarten/map.png',
            //size: [50,50] //cuts off picture
            scale: 0.075
        }),
    });     
  }
  else if (Mobile_Klasse=='Restaurant'){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Landschaftsgarten/restaurant.png',
            //size: [50,50] //cuts off picture
            scale: 0.04
        }),
    });     
  }
}

function getSchiffFeatures(){
    SchiffSource.clear();
    $.getJSON('../../lib7/sources/Rethra/shape/fahrten.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Mobile_Klasse', 'Fahrten');
                SchiffSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });
    $.getJSON('../../lib7/sources/Rethra/shape/point.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Mobile_Klasse', 'Point');
                SchiffSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });
    $.getJSON('../../lib7/sources/Rethra/shape/rethra.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Mobile_Klasse', 'Rethra');
                SchiffSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });
    $.getJSON('../../lib7/sources/Rethra/shape/schiff.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Mobile_Klasse', 'Schiff');
                SchiffSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            SchiffVector.setStyle(getStyleSchiffWithLabel);
}
function getStyleSchiffWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Titel';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = true;
    var widthBorder = 4;
    var radiusPoint = 10;

    var Mobile_Klasse=feature.get('Mobile_Klasse');
  if (Mobile_Klasse=='Fahrten'){
    var colorFill = 'rgba(233, 115, 0, 0)';
    var colorStroke = 'rgba(255, 255, 255, 0)';
      var lineDashArray = [5, 0];
    var widthBorder = 1;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
  }
  else if (Mobile_Klasse=='Point'){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Schiff/anker.png',
            //size: [50,50] //cuts off picture
            scale: 0.5
        }),
    });     
  }
  else if (Mobile_Klasse=='Rethra'){
    var colorFill = 'rgba(68, 194, 199, 1)';
    var colorStroke = 'rgba(68, 194, 199, 1)';
      var lineDashArray = [5, 0];
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
  }
  else if (Mobile_Klasse=='Schiff'){
    var colorFill = 'rgba(233, 115, 0, 1)';
    var colorStroke = 'rgba(13, 76, 141, 1)';        
      var lineDashArray = [5, 0];
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
  }
}

function getStrandAugustabadFeatures(){
    StrandAugustabadSource.clear();
    $.getJSON('../../lib7/sources/Badestrand/shape/strand_augustabad.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                StrandAugustabadSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            StrandAugustabadVector.setStyle(getStyleStrandIcon);
}
function getStrandBrodaFeatures(){
    StrandBrodaSource.clear();
    $.getJSON('../../lib7/sources/Badestrand/shape/strand_broda.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                StrandBrodaSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            StrandBrodaVector.setStyle(getStyleStrandIcon);
}
function getStrandFeatures(){
    StrandSource.clear();
    $.getJSON('../../lib7/sources/Badestrand/shape/strand.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                StrandSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            StrandVector.setStyle(getStyleStrandIcon);
}
function getStyleStrandIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Strand/Piktogramm_Schwimmen_Blau.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });     
}

function getStadtrundgangFeatures(){
    StadtrundgangSource.clear();
    $.getJSON('../../lib7/sources/Stadtrundgang/shape/point-rundgang.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                StadtrundgangSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            StadtrundgangVector.setStyle(getStyleStadtrundgangIcon);
}
function getStyleStadtrundgangIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Rundgang/Pikto.png',
            //size: [50,50] //cuts off picture
            scale: 0.5
        }),
    });     
}

function getLandschaftsgartenFeatures(){
    LandschaftsgartenSource.clear();
    $.getJSON('../../lib7/sources/Landschaftsgarten/shape/pointinterest.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                LandschaftsgartenSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            LandschaftsgartenVector.setStyle(getStyleLandschaftsgartenIcon);
}
function getStyleLandschaftsgartenIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Landschaftsgarten/map.png',
            //size: [50,50] //cuts off picture
            scale: 0.075
        }),
    });     
}

function getE_LadeFeatures(){
    E_LadeSource.clear();
    $.getJSON('../../lib7/sources/E-Ladestation/shape/eLade_PKW.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Klasse', 'PKW');
                E_LadeSource.addFeature(element);

        }
    });
    $.getJSON('../../lib7/sources/E-Ladestation/shape/eLade_Fahrrad.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
            element.set('Klasse', 'Fahrrad');
                E_LadeSource.addFeature(element);

        }
    });

            E_LadeVector.setStyle(getStyleE_LadeIcon);
}
function getStyleE_LadeIcon(feature){
    var Klasse = feature.get('Klasse');
    if (Klasse=='Fahrrad'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/E-Ladestation/eLadeFahrrad_5.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });     
    }
    else if (Klasse=='PKW'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/E-Ladestation/eLadePKW_4.png',
                //size: [50,50] //cuts off picture
                scale: 0.35
            }),
        });     
    }
}

function getSpurensucheFeatures(){
    SpurensucheSource.clear();
    $.getJSON('../../lib7/sources/Stelen/shape/stelen.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                SpurensucheSource.addFeature(element);
            //document.getElementById('display').innerHTML+= inc + ' vvv vvv ';
        }
    });
            SpurensucheVector.setStyle(getStyleSpurensucheIcon);
}
function getStyleSpurensucheIcon(feature){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Stelen/marker_rot.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });     
}

                                    /////////////////////////// Leben und Wohnen ///////////////////////////

function getStandesamtFeatures(){
    StandesamtSource.clear();
    $.getJSON('../../lib7/sources/Standesamt/shape/Standesamt.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                StandesamtSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            StandesamtVector.setStyle(getStyleStandesamtIcon);
}
function getStyleStandesamtIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_gruen.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });     
}

function getFriedhofFeatures(){
    FriedhofSource.clear();
    $.getJSON('../../lib7/sources/Friedhof/shape/friedhof.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                FriedhofSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            FriedhofVector.setStyle(getStyleFriedhofWithLabel);
}
function getStyleFriedhofWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(47, 156, 28, 1)';       
    var colorText = 'rgba(255, 0, 0, 1)';
    var colorStroke = 'rgba(255, 255, 255, 1)';
    var lineDashArray = [5, 0];
    var fontLayer = '70px arial';
    var label = 'Titel';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getIntegration_BehoerdenFeatures(){
    IntegrationSource.clear();
    $.getJSON('../../lib7/sources/Integration/shape/integration.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Bereich_Ti');
    if (Klasse=='Behörden'){
                IntegrationSource.addFeature(element);
    }

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            IntegrationVector.setStyle(getStyleIntegrationIcon);
}
function getIntegration_BeratungFeatures(){
    IntegrationSource.clear();
    $.getJSON('../../lib7/sources/Integration/shape/integration.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Bereich_Ti');
    if (Klasse=='Beratung'){
                IntegrationSource.addFeature(element);
    }

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            IntegrationVector.setStyle(getStyleIntegrationIcon);
}
function getIntegration_BetreuungFeatures(){
    IntegrationSource.clear();
    $.getJSON('../../lib7/sources/Integration/shape/integration.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Bereich_Ti');
    if (Klasse=='Betreuung'){
                IntegrationSource.addFeature(element);
    }

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            IntegrationVector.setStyle(getStyleIntegrationIcon);
}
function getIntegration_BildungseinrichtungenFeatures(){
    IntegrationSource.clear();
    $.getJSON('../../lib7/sources/Integration/shape/integration.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Bereich_Ti');
    if (Klasse=='Bildungseinrichtungen'){
                IntegrationSource.addFeature(element);
    }

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            IntegrationVector.setStyle(getStyleIntegrationIcon);
}
function getIntegration_FreizeitangeboteFeatures(){
    IntegrationSource.clear();
    $.getJSON('../../lib7/sources/Integration/shape/integration.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Bereich_Ti');
    if (Klasse=='Begegnungsstätten und Freizeitangebote'){
                IntegrationSource.addFeature(element);
    }

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            IntegrationVector.setStyle(getStyleIntegrationIcon);
}
function getIntegration_WohnenFeatures(){
    IntegrationSource.clear();
    $.getJSON('../../lib7/sources/Integration/shape/integration.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
    var Klasse = element.get('Bereich_Ti');
    if (Klasse=='Wohnen'){
                IntegrationSource.addFeature(element);
    }

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            IntegrationVector.setStyle(getStyleIntegrationIcon);
}
function getIntegrationFeatures(){
    IntegrationSource.clear();
    $.getJSON('../../lib7/sources/Integration/shape/integration.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                IntegrationSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            IntegrationVector.setStyle(getStyleIntegrationIcon);
}
function getStyleIntegrationIcon(feature){        //kann nicht mit Umlauten in UTF-8 vergleichen
    var Klasse = feature.get('Bereich_Ti');
    if (Klasse=='Begegnungsstätten und Freizeitangebote'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_braun.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if (Klasse=='Behörden'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_rot.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if (Klasse=='Beratung'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_magenta.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if (Klasse=='Betreuung'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_lila.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if (Klasse=='Bildungseinrichtungen'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_gruen.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if (Klasse=='Wohnen'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_gelb.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }   
}

function getHundeAlleFeatures(){
    HundeAlleSource.clear();
    $.getJSON('../../lib7/sources/Hundefreilaufflaechen/shape/Hunde_alle.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    HundeAlleSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            HundeAlleVector.setStyle(getStyleHundeAlleWithLabel);

}
function getStyleHundeAlleWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(238, 0, 0, 0.4)';
    var colorStroke = 'rgba(0, 0, 0, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Nummer';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getHunde40cmFeatures(){
    Hunde40cmSource.clear();
    $.getJSON('../../lib7/sources/Hundefreilaufflaechen/shape/Hunde_40cm.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    Hunde40cmSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            Hunde40cmVector.setStyle(getStyleHunde40cmWithLabel);
}
function getStyleHunde40cmWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(255, 255, 0, 0.4)';
    var colorStroke = 'rgba(0, 0, 0, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Nummer';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getHundeTuetenFeatures(){
    HundeTuetenSource.clear();
    $.getJSON('../../lib7/sources/Hundefreilaufflaechen/shape/Tueten.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    HundeTuetenSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            HundeTuetenVector.setStyle(getStyleHundeTuetenIcon);
}
function getStyleHundeTuetenIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Hunde/map.png',
            //size: [50,50] //cuts off picture
//            opacity: 0.5,
            scale: 0.15
        }),
    });     
}

function getHundeStrandFeatures(){
    HundeStrandSource.clear();
    $.getJSON('../../lib7/sources/Hundefreilaufflaechen/shape/Hundestrand.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    HundeStrandSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            HundeStrandVector.setStyle(getStyleHundeStrandIcon);
}
function getStyleHundeStrandIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_gruen.png',
            //size: [50,50] //cuts off picture
//            opacity: 0.5,
            scale: 0.05
        }),
    });     
}

function getHundeZeitFeatures(){
    HundeZeitSource.clear();
    $.getJSON('../../lib7/sources/Hundefreilaufflaechen/shape/zeit.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    HundeZeitSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            HundeZeitVector.setStyle(getStyleHundeZeitIcon);
}
function getStyleHundeZeitIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_schwarz.png',
            //size: [50,50] //cuts off picture
//            opacity: 0.5,
            scale: 0.05
        }),
    });     
}

function getHundeFeatures(){
    HundeSource.clear();
    $.getJSON('../../lib7/sources/Hundefreilaufflaechen/shape/Hunde.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    HundeSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            HundeVector.setStyle(getStyleHundeWithLabel);
}
function getStyleHundeWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(0, 153, 0, 0.4)';
    var colorStroke = 'rgba(34, 0, 255, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 1)';
    var fontLayer = '27px arial';
    var label = 'Nummer';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

                                    /////////////////////////// Sicherheit und Ordnung ///////////////////////////

function getCityWCFeatures(){
    CityWCSource.clear();
    $.getJSON('../../lib7/sources/City-WC/shape/WC.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                CityWCSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            CityWCVector.setStyle(getStyleCityWCIcon);
}
function getStyleCityWCIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/WC/citywc_logo.png',
            //size: [50,50] //cuts off picture
            scale: 0.2
        }),
    });     
}

function getReinigungFeatures(){
    ReinigungSource.clear();
    $.getJSON('../../lib7/sources/Reinigung/shape/Klasse_all.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    ReinigungSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            ReinigungVector.setStyle(getStyleReinigungWithLabel);
}
function getStyleReinigungWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(255, 255, 0, 1)';
    var lineDashArray = [5, 0];
    var colorText = 'rgba(0, 0, 0, 0)';
    var fontLayer = '27px arial';
    var label = 'Nummer';
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 10;
    var radiusPoint = 10;
    var lineDashArray = [5,0];

    var Klasse = feature.get('Klasse');
    if (Klasse=='0'){
        var colorStroke = 'rgba(255, 0, 0, 1)';             
    }     
    else if (Klasse=='1'){
        var colorStroke = 'rgba(46, 46, 254, 1)';        
    }     
    else if (Klasse=='2'){
        var colorStroke = 'rgba(0, 204, 0, 1)';
    }     
    else if (Klasse=='3'){                  
        var colorStroke = 'rgba(255, 170, 0, 1)';      
    }     
    else if (Klasse=='4'){
        var colorStroke = 'rgba(192, 0, 192, 1)';    
    }     
    else if (Klasse=='5'){
        var colorStroke = 'rgba(128, 128, 0, 1)';      
    }     
    else if (Klasse=='6'){
        var colorStroke = 'rgba(255, 128, 0, 1)';         
    }     
    else if (Klasse=='7'){
        var colorStroke = 'rgba(0, 255, 255, 1)';           
    }     
    var strokeText = 'rgba(255, 255, 255, 0)'; 

    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getWinterdienst1Features(){
    Winterdienst1Source.clear();
    $.getJSON('../../lib7/sources/Winterdienst/shape/Winterdienst I_L_4.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    Winterdienst1Source.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            Winterdienst1Vector.setStyle(getStyleWinterdienst1WithLabel);
}
function getStyleWinterdienst1WithLabel(feature){
    //Werte f�r meisten Klassen
    var colorStroke = 'rgba(255, 0, 0, 1)';
    var lineDashArray = [5, 0];
    var colorFill = 'rgba(255, 255, 0, 1)';
    var colorText = 'rgba(0, 0, 0, 0)';
    var fontLayer = '27px arial';
    var label = 'Nummer';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 6;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getWinterdienst2Features(){
    Winterdienst2Source.clear();
    $.getJSON('../../lib7/sources/Winterdienst/shape/Winterdienst II_L_4.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                    Winterdienst2Source.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            Winterdienst2Vector.setStyle(getStyleWinterdienst2WithLabel);
}
function getStyleWinterdienst2WithLabel(feature){
    //Werte f�r meisten Klassen
    var colorStroke = 'rgba(46, 46, 254, 1)';
    var lineDashArray = [5, 0];
    var colorFill = 'rgba(255, 255, 0, 1)';
    var colorText = 'rgba(0, 0, 0, 0)';
    var fontLayer = '27px arial';
    var label = 'Nummer';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 6;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

function getParkplatzBusFeatures(){
    ParkplatzBusSource.clear();
    $.getJSON('../../lib7/sources/Parkplatz/shape/bus.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                ParkplatzBusSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            ParkplatzBusVector.setStyle(getStyleParkplatzBusIcon);
}
function getStyleParkplatzBusIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Parken/bus_blau.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });     
}

function getParkplatzLKWFeatures(){
    ParkplatzLKWSource.clear();
    $.getJSON('../../lib7/sources/Parkplatz/shape/lkw.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                ParkplatzLKWSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            ParkplatzLKWVector.setStyle(getStyleParkplatzLKWIcon);
}
function getStyleParkplatzLKWIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Parken/truck_blau.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });     
}

function getParkplatzParkFeatures(){
    ParkplatzParkSource.clear();
    $.getJSON('../../lib7/sources/Parkplatz/shape/park.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                ParkplatzParkSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            ParkplatzParkVector.setStyle(getStyleParkplatzParkIcon);
}
function getStyleParkplatzParkIcon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Landschaftsgarten/p_bild.png',
            //size: [50,50] //cuts off picture
            scale: 0.75
        }),
    });     
}

function getP15Features(){
    P15Source.clear();
    $.getJSON('../../lib7/sources/P15/shape/p15.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                P15Source.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            P15Vector.setStyle(getStyleP15Icon);
}
function getStyleP15Icon(){
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/marker_lila.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });     
}

function getFruehjahrsputzFeatures(){
    FruehjahrsputzSource.clear();
    $.getJSON('../../lib7/sources/Fruehjahrsputz/shape/friedhof.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                FruehjahrsputzSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            FruehjahrsputzVector.setStyle(getStyleFruehjahrsputzWithLabel);
}
function getStyleFruehjahrsputzWithLabel(feature){
    //Werte f�r meisten Klassen
    var colorFill = 'rgba(47, 156, 28, 1)';       
    var colorText = 'rgba(255, 0, 0, 1)';
    var colorStroke = 'rgba(255, 255, 255, 1)';
    var lineDashArray = [5, 0];
    var fontLayer = '70px arial';
    var label = 'Titel';
    var strokeText = 'rgba(255, 255, 255, 0)'; 
    var widthLabelBorder = 0; 
    var overflowLabel = false;
    var widthBorder = 1;
    var radiusPoint = 10;
    return createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint);
}

                                    /////////////////////////// Bildung und Sport ///////////////////////////

function getSchulenFeatures() {
    SchulenSource.clear();
    $.getJSON('../../lib7/sources/Schulen/shape/schule.geojson', function (data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++) {
            var element = ObjectArray.pop();
            SchulenSource.addFeature(element);
        }
    });
    SchulenVector.setStyle(getStyleSchulenIcon);
}
function getStyleSchulenIcon() {
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Schule/school.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });
}
function getKitasFeatures() {
    KitasSource.clear();
    $.getJSON('../../lib7/sources/Kitas/shape/kitas.geojson', function (data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++) {
            var element = ObjectArray.pop();
            KitasSource.addFeature(element);
        }
    });
    KitasVector.setStyle(getStyleKitasIcon);
}
function getStyleKitasIcon() {
    return new Style({
        image: new Icon({
            src: 'https://geoserver.neubrandenburg.de/Bilder/Kitas/kitas.png',
            //size: [50,50] //cuts off picture
            scale: 0.05
        }),
    });
}

function getSportplaetzeFeatures(){
    SportplaetzeSource.clear();
    $.getJSON('../../lib7/sources/Sportplaetze/shape/sport_all.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                SportplaetzeSource.addFeature(element);

        }
        //document.getElementById('display').innerHTML+=JSON.stringify(data);
        //document.getElementById('display').innerHTML+=JSON.stringify(element.values_.BEARBEIT);
    });

            SportplaetzeVector.setStyle(getStyleSportplaetzeIcon);
}
function getStyleSportplaetzeIcon(feature){
    var Klasse = feature.get('KATEGORIE');
    if (Klasse=='Plätze'){                    //kann nicht mit Umlauten in UTF-8 vergleichen
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Sport/Piktogramm_Sport_hellblau.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if ((Klasse=='Halle') || (Klasse=='Hallen')){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Sport/Piktogramm_Sport_gruen.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if ((Klasse=='Kulturpark') || (Klasse=='Sonstige')){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Sport/Piktogramm_Sport_schwarz.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
}

function getSpielplaetzeFeatures(){
    SpielplaetzeSource.clear();
    $.getJSON('../../lib7/sources/Spielplaetze/shape/spielplatz.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                element.set('KlasseMobile', '1');
                SpielplaetzeSource.addFeature(element);

        }
    });
    $.getJSON('../../lib7/sources/Spielplaetze/shape/spielplatz2.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                element.set('KlasseMobile', '2');
                SpielplaetzeSource.addFeature(element);

        }
    });
    $.getJSON('../../lib7/sources/Spielplaetze/shape/spielplatz3.geojson', function(data) {
        var ObjectArray = new GeoJSON().readFeatures(data);
        //ObjectArray=data['features'];
//        BeschilderungSource.addFeatures(ObjectArray);
        var numberOfElements = ObjectArray.length;
        for (var inc = 0; inc < numberOfElements; inc++){
            var element = ObjectArray.pop();
                element.set('KlasseMobile', '3');
                SpielplaetzeSource.addFeature(element);

        }
    });

            SpielplaetzeVector.setStyle(getStyleSpielplaetzeIcon);
}
function getStyleSpielplaetzeIcon(feature){
    var Klasse = feature.get('KlasseMobile');
    if (Klasse=='1'){                    //kann nicht mit Umlauten in UTF-8 vergleichen
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/spiel_g.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if (Klasse=='2'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/ball_weiss.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
    else if (Klasse=='3'){
        return new Style({
            image: new Icon({
                src: 'https://geoserver.neubrandenburg.de/Bilder/Marker/Ballspiel_gruen.png',
                //size: [50,50] //cuts off picture
                scale: 0.05
            }),
        });
    }     
}

                                    /////////////////////////// Umwelt ///////////////////////////

                                    /////////////////////////// Weitere Karten ///////////////////////////


                                ///// ---- Ende Get Objects des Layers ---- /////


// -- Beginn Style der GEOJSON mit Label
function createStyleLayer(feature, colorFill, colorStroke, lineDashArray, colorText, strokeText, widthLabelBorder, fontLayer, label, overflowLabel, widthBorder, radiusPoint){
    return new Style({
          fill: new Fill({
            color: colorFill
          }),
          stroke: new Stroke({
            color: colorStroke,
              width: widthBorder,
              lineDash: lineDashArray //[5, 0]
          }),
          image: new CircleStyle({
            radius: radiusPoint,
            fill: new Fill({
              color: colorFill
            }),
            stroke: new Stroke({
              color: colorStroke,
              width: widthBorder
            })
          }),
          text: createTextStyle(feature, label, overflowLabel, colorText, strokeText, widthLabelBorder, fontLayer)
    });         
}

function createTextStyle(feature, label, overflowLabel, colorText, strokeText, widthLabelBorder, fontLayer){
  return new TextStyle({
    font: fontLayer,
    text: getTextLayer(feature, label),
    fill: new Fill({color: colorText}),
    overflow: overflowLabel,
    stroke: new Stroke({color: strokeText, width: widthLabelBorder})
  });         
}

function getTextLayer(feature, label){
    return feature.get(label);
}
// -- Ende Style der GEOJSON

function buildTab(layer, title){
    //bewirkt, dass nur der erste Layer beim Aufruf des Templates aktiv
    var activeClass;
    if ((document.getElementById('TemplateTabsInc') == undefined)){ //wenn kein Element mit der id existiert
        document.getElementById("TemplateTabs").innerHTML+=
            '<input id="TemplateTabsInc" type="hidden"/>';
        activeClass='active';
    }
    else {
        activeClass='';
    }
    
    if ((document.getElementById(layer+'Tab') == undefined)){ //wenn kein Element mit der id existiert
        document.getElementById("TemplateTabs").innerHTML+=
            '<li class="nav-item" id="'+layer+'Tab">'+
              '<a class="nav-link '+activeClass+'" data-toggle="tab" href="#'+layer+'TemplateContent">'+title+'</a>'+
            '</li>'+
        '';
    }
    if ((document.getElementById(layer+'TemplateContent') == undefined)){ //wenn kein Element mit der id existiert
        document.getElementById("TemplateContents").innerHTML+=
            '<div id="'+layer+'TemplateContent" class="container tab-pane '+activeClass+'">'+
            '</div>'+
        '';
    }    
}

function replaceSonderzeichen(stringOld){
     var stringNew = stringOld;
     stringNew = stringNew.replaceAll('+', ' ');
     stringNew = stringNew.replaceAll('%2C',',');
     stringNew = stringNew.replaceAll('%C3%84', 'Ä');     //�
     stringNew = stringNew.replaceAll('%C3%A4', 'ä');     //�
     stringNew = stringNew.replaceAll('%C3%96', 'Ö');     //�
     stringNew = stringNew.replaceAll('%C3%B6', 'ö');     //�
     stringNew = stringNew.replaceAll('%C3%9C', 'Ü');     //�
     stringNew = stringNew.replaceAll('%C3%BC', 'ü');     //�
     stringNew = stringNew.replaceAll('%C3%9F', 'ß');     //�
     return stringNew;    
}

//Bewirkt, dass der Startbildschirm geschlossen und das eigentliche Programm gestartet wird
function showPage() {
    document.getElementById("bodyReal").style.display = "block";
   // document.getElementById("bodyReal").style.visibility = "visible";
    document.getElementById("bodyStart").style.display = "none";
    document.getElementById('formStart').submit();

}

if (firstLoad != 'false') {
    //Bewirkt, dass der Startbildschirm angezeigt und das eigentliche Programm versteckt wird
    document.getElementById("bodyStart").style.display = "block";
    document.getElementById("bodyReal").style.display = "none";

    //Bewirkt, dass <bodyStart> auf gesamten Bildschrim

    var w = window.innerWidth; //Breite des aktuellen Fensters
    var h = window.innerHeight; //H�he des aktuellen Fensters
    document.getElementById("bodyStart").style.height = h + "px";  //Container mit Hintergrundfarbe �ber die gesamte Fl�che
    document.getElementById("bodyStart").style.width = w + "px";

    document.getElementById("oneAndAHalf").style.height = (h - document.getElementById("secondRowStart").offsetHeight) / 2 - document.getElementById("firstRowStart").offsetHeight + "px";

    //Ermittelt Position des Ladekreises.
    var surround = 125;
    var size = (document.getElementById('LoadingScreen').offsetWidth - 0 * surround);
    if (size > h) {
        size = h - 50;
    }

    //Ladekreis erstellt �ber ein rotierendes Canvas welches einen Kreisbogen enth�lt
    //Bewirkt, dass der Ladekreis �ber der Begr��ungsschrift auftaucht
    var size = (document.getElementById('LoadingScreen').offsetWidth - 0 * surround);
    if (size > h / 2 - 50) {
        size = h / 2 - 50;
    }

    document.getElementById("secondRowStart").style.height = h / 2 - 30 + "px";
    document.getElementById("oneAndAHalf").style.height = (h - document.getElementById("secondRowStart").offsetHeight) - document.getElementById("firstRowStart").offsetHeight + "px";

    document.getElementById('loaderCanvas').style.height = size + "px";
    document.getElementById('loaderCanvas').style.width = size + "px";
    document.getElementById('loaderCanvas').style.top = h / 4 - size / 2 + 30 + "px";
    document.getElementById('loaderCanvas').style.left = w / 2 - size / 2 + "px";
    var c = document.getElementById('loaderCanvas');
    var ctx = c.getContext("2d");
    var gradient = ctx.createLinearGradient(0, 0, 200, 0);
    gradient.addColorStop("0", "rgba(25,164,55,0)");
    gradient.addColorStop("1.0", "#19a437");
    ctx.strokeStyle = gradient;
    ctx.lineWidth = 10;
    ctx.beginPath();
    size = document.getElementById('loaderCanvas').width / 2;
    ctx.arc(size, size, size - ctx.lineWidth, 1 * Math.PI, 1.8 * Math.PI); //gradient wird erstellt von 1*Math.PI bis 2*Math.PI
    ctx.stroke();

    setTimeout(showPage, 3000);     //rufe die Funktion showPage() nach 6s auf
    //setTimeout(showPage, 1000000);
    //setTimeout(showPage, 1);
}
                                        
